import React, { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import Header from '../components/Header/Header';
import Footer from '../components/Footer/Footer';
import SVGIcon from '../components/SVGIcon/SVGIcon';
import AuthModal from '../components/AuthModal/AuthModal';
import ProductDetails from '../components/ProductDetails/ProductDetails';
import { localProducts } from '../data/localDb';
import BlogDetails from '../components/BlogDetails/BlogDetails';
import ShopPage from '../components/ShopPage/ShopPage';
import KnowledgeHub from '../components/KnowledgeHub/KnowledgeHub';
import AdminDashboard from '../components/AdminDashboard/AdminDashboard';
import CheckoutPage from '../components/CheckoutPage/CheckoutPage';
import MyOrdersPage from '../components/MyOrdersPage/MyOrdersPage';
import ProfilePage from '../components/ProfilePage/ProfilePage';
import NotFound from '../components/NotFound/NotFound';
import PestDiseasesPage from '../components/PestDiseasesPage/PestDiseasesPage';
import ProductRangePage from '../components/ProductRangePage/ProductRangePage';
import { SearchService } from '../services/SearchService';
import axios from 'axios';
import { API_BASE_URL } from '../config';
import AboutUs from '../components/AboutUs/AboutUs';
import ContactUs from '../components/ContactUs/ContactUs';
import AppComingSoon from '../components/AppComingSoon/AppComingSoon';
import HelpCenter from '../components/HelpCenter/HelpCenter';
import { GiPlantSeed, GiPlantRoots, GiWaterDrop, GiEcology, GiPlantWatering, GiFertilizerBag, GiGreenhouse, GiSeedling } from 'react-icons/gi';
import { FiShield, FiTruck, FiAward } from 'react-icons/fi';
import { FaLeaf, FaStar, FaStarHalfAlt } from 'react-icons/fa';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import './landing.css';

// Force rebuild to sync latest CSS changes
gsap.registerPlugin(ScrollTrigger);

const getProductOrderWeight = (nameOrTitle) => {
  const t = (nameOrTitle || '').toLowerCase();
  if (t.includes('super novel')) return 0;
  if (t.includes('super prime')) return 2;
  if (t.includes('super plus')) return 4;
  if (t.includes('super')) return 1;
  if (t.includes('prime')) return 3;
  if (t.includes('plus')) return 5;
  if (t.includes('enriched organic manure')) return 6;
  if (t.includes('organic manure')) return 7;
  if (t.includes('vermicompost')) return 8;
  return 99;
};

// Dynamic consistent product rating & reviews mapping
const getProductRating = (titleStr) => {
  return (titleStr || '').toLowerCase().includes('super novel') ? 4.5 : 4.0;
};

const getProductReviewsCount = (titleStr) => {
  const t = (titleStr || '').toLowerCase();
  if (t.includes('super novel')) return 148;
  if (t.includes('super plus')) return 87;
  if (t.includes('super prime')) return 92;
  if (t.includes('super')) return 76;
  if (t.includes('prime')) return 64;
  if (t.includes('plus')) return 58;
  if (t.includes('enriched organic manure')) return 72;
  if (t.includes('organic manure')) return 50;
  if (t.includes('vermicompost')) return 98;
  return 45;
};

// Database of all products for slug resolution
const allProductsList = [
  { id: 1, title: "Super Novel", price: 1417.50, image: "/products/bio-orbi-super-novel.png" },
  { id: 2, title: "Prime", price: 160.00, image: "/products/bio-orbi-prime.png" },
  { id: 3, title: "Plus", price: 230.00, image: "/products/bio-orbi-plus.png" },
  { id: 4, title: "Organic Manure", price: 170.28, image: "/products/Organic Manure.png" },
  { id: 5, title: "Vermicompost", price: 120.00, image: "/products/Vermicompost.png" },
  { id: 6, title: "Enriched Organic Manure", price: 120.00, image: "/products/Enriched Organic Manure.png" }
];

export default function Landing({ activeTab }) {
  const [selectedLang, setSelectedLang] = useState('en');
  const [selectedCurr, setSelectedCurr] = useState('INR');
  const [dbProducts, setDbProducts] = useState([]);
  const [bannerBgError, setBannerBgError] = useState(false);

  useEffect(() => {
    const img = new Image();
    img.src = "/banner/orbifert_landing_mid_banner_bg.png";
    img.onerror = () => {
      setBannerBgError(true);
    };
  }, []);




  // Authentication State
  const [currentUser, setCurrentUser] = useState(null);

  // Global Shopping & Wishlist states
  const [cartItems, setCartItems] = useState([]);
  const [wishlistItems, setWishlistItems] = useState([]);



  const handleVideoPlay = (e) => {
    e.target.playbackRate = 2.0;
  };

  // Sidebar visibility states
  const [isCartOpen, setIsCartOpen] = useState(false);
  const [isWishlistOpen, setIsWishlistOpen] = useState(false);



  // Selected blog detail page state
  const [selectedBlog, setSelectedBlog] = useState(null);

  const [latestBlogs, setLatestBlogs] = useState([
    {
      id: 1,
      date: "18", month: "NOV",
      title: "Curabitur porttitor orci eget neque accumsan venenatis. Nunc fermentum.",
      image: "https://images.unsplash.com/photo-1592982537447-6f2a6a0c7c18?w=400&auto=format&fit=crop&q=60",
      category: "Food",
      author: "Admin",
      commentsCount: 65,
      summary: "Discover the best practices for organic food preservation and sustainable distribution models."
    },
    {
      id: 2,
      date: "29", month: "JAN",
      title: "Eget lobortis lorem lacinia. Vivamus pharetra semper.",
      image: "https://images.unsplash.com/photo-1593113598332-cd288d649433?w=400&auto=format&fit=crop&q=60",
      category: "Farming",
      author: "Admin",
      commentsCount: 65,
      summary: "Exploring modern biofertilizer applications and their quantitative impact on nitrogen fixation."
    },
    {
      id: 3,
      date: "21", month: "FEB",
      title: "Maecenas blandit risus elementum mauris malesuada.",
      image: "https://images.unsplash.com/photo-1599599810769-bcde5a160d32?w=400&auto=format&fit=crop&q=60",
      category: "Bio Pest",
      author: "Admin",
      commentsCount: 65,
      summary: "How biocontrol agents act as organic barriers against root-borne fungal diseases."
    },
    {
      id: 4,
      date: "18", month: "NOV",
      title: "Curabitur porttitor orci eget neque accumsan venenatis. Nunc fermentum.",
      image: "https://images.unsplash.com/photo-1574323347407-f5e1ad6d020b?w=400&auto=format&fit=crop&q=60",
      category: "Organic",
      author: "Admin",
      commentsCount: 65,
      summary: "Discover the best practices for organic food preservation and sustainable distribution models."
    }
  ]);

  useEffect(() => {
    SearchService.getAllBlogs().then(data => {
      if (data && data.length > 0) {
        const normalized = data.map(b => ({
          ...b,
          image: b.image || b.image_url || 'https://images.unsplash.com/photo-1574323347407-f5e1ad6d020b?w=800&auto=format&fit=crop&q=80',
          date: b.date || (b.created_at ? new Date(b.created_at).getDate().toString() : '01'),
          month: b.month || (b.created_at ? ['JAN', 'FEB', 'MAR', 'APR', 'MAY', 'JUN', 'JUL', 'AUG', 'SEP', 'OCT', 'NOV', 'DEC'][new Date(b.created_at).getMonth()] : 'JAN'),
          author: b.author || (b.first_name ? `${b.first_name} ${b.last_name}` : 'Admin'),
          commentsCount: b.commentsCount !== undefined ? b.commentsCount : (b.comments ? b.comments.length : 0),
          summary: b.summary || b.content?.slice(0, 100) + '...' || ''
        }));
        setLatestBlogs(normalized.slice(0, 4));
      }
    }).catch(err => {
      console.warn("Failed to fetch blogs for landing page:", err);
    });
  }, []);

  // Video promo modal state
  const [isVideoModalOpen, setIsVideoModalOpen] = useState(false);

  // Active full-page view: 'home' | 'shop' | 'knowledge'
  const activePage = activeTab || 'home';

  const navigate = useNavigate();
  const { slug, id } = useParams();

  // Selected product detail page state
  const selectedProduct = React.useMemo(() => {
    if (activePage !== 'product' || !slug) return null;
    // Find matching product in localDb by slug
    const found = localProducts.find(p => p.slug === slug);
    if (found) return found;

    // Fallback title-to-slug match
    const foundByTitle = localProducts.find(p => {
      const pSlug = p.title.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/(^-|-$)/g, '');
      return pSlug === slug;
    });
    if (foundByTitle) return foundByTitle;

    const reconstructedTitle = slug?.split('-')
      .map(w => w.charAt(0).toUpperCase() + w.slice(1))
      .join(' ');
    return { id: 999, title: reconstructedTitle || '', price: 140.99, images: ["/products/bio-orbi-super-novel.png"] };
  }, [activePage, slug]);

  useEffect(() => {
    if (activeTab === 'blog' && slug) {
      SearchService.getBlogBySlug(slug).then(found => {
        if (found) {
          setSelectedBlog(found);
        } else {
          const reconstructedTitle = slug.split('-')
            .map(w => w.charAt(0).toUpperCase() + w.slice(1))
            .join(' ');
          setSelectedBlog({
            id: 99,
            title: reconstructedTitle,
            category: "Organic",
            image: "https://images.unsplash.com/photo-1592982537447-6f2a6a0c7c18?w=400&auto=format&fit=crop&q=60",
            date: "12",
            month: "JUN",
            summary: "Organic farming is an agricultural method that aims to produce food using natural substances and processes."
          });
        }
      });
    } else {
      setSelectedBlog(null);
    }
  }, [activeTab, slug]);

  const navigateToProduct = (prod) => {
    const titleToUse = prod.title || prod.name || "";
    const slugVal = titleToUse.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/(^-|-$)/g, '');
    setIsCartOpen(false);
    setIsWishlistOpen(false);
    navigate(`/product/${slugVal}`);
    window.scrollTo(0, 0);
  };

  const navigateToBlog = (blog) => {
    const slugVal = blog.slug || blog.title.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/(^-|-$)/g, '');
    setIsCartOpen(false);
    setIsWishlistOpen(false);
    navigate(`/blog/${slugVal}`);
    window.scrollTo(0, 0);
  };

  const handleNavigate = (hash) => {
    setSelectedBlog(null);

    // Handle dedicated page routes
    if (hash === '#products' || hash === 'products' || hash === '#our-products' || hash === 'our-products') {
      navigate('/our-products');
      window.scrollTo(0, 0);
      return;
    }
    if (hash === '#about' || hash === 'about') {
      navigate('/about');
      window.scrollTo(0, 0);
      return;
    }
    if (hash === '#shop' || hash === 'shop') {
      navigate('/shop');
      window.scrollTo(0, 0);
      return;
    }
    if (hash === '#knowledge' || hash === 'knowledge') {
      navigate('/knowledge-hub');
      window.scrollTo(0, 0);
      return;
    }
    if (hash === '#contact' || hash === 'contact') {
      navigate('/contact');
      window.scrollTo(0, 0);
      return;
    }
    if (hash === '#help-center' || hash === 'help-center' || hash === '#faqs' || hash === 'faqs') {
      navigate('/help-center');
      window.scrollTo(0, 0);
      return;
    }
    if (hash === '#ios-app' || hash === 'ios-app') {
      navigate('/ios-app');
      window.scrollTo(0, 0);
      return;
    }
    if (hash === '#apk-app' || hash === 'apk-app' || hash === '#android-app' || hash === 'android-app') {
      navigate('/apk-app');
      window.scrollTo(0, 0);
      return;
    }

    if (activeTab !== 'home') {
      navigate('/');
    }

    if (hash) {
      setTimeout(() => {
        const targetId = hash.replace('#', '');
        const element = document.getElementById(targetId);
        if (element) {
          element.scrollIntoView({ behavior: 'smooth' });
        }
      }, 150);
    } else {
      window.scrollTo(0, 0);
    }
  };


  // Check for existing user session
  const checkUserSession = () => {
    const token = localStorage.getItem('token');
    if (token) {
      axios.get(`${API_BASE_URL}/auth/profile`, {
        headers: { 'Authorization': `Bearer ${token}` }
      })
        .then(res => {
          setCurrentUser(res.data.user);
        })
        .catch(err => {
          console.warn('Auto-login failed:', err.message);
          localStorage.removeItem('token');
          localStorage.removeItem('user');
          setCurrentUser(null);
          window.dispatchEvent(new CustomEvent('auth-state-change'));
        });
    } else {
      setCurrentUser(null);
    }
  };

  useEffect(() => {
    checkUserSession();
    window.addEventListener('auth-state-change', checkUserSession);
    return () => {
      window.removeEventListener('auth-state-change', checkUserSession);
    };
  }, []);

  const handleLogout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    setCurrentUser(null);
    window.dispatchEvent(new CustomEvent('auth-state-change'));
    triggerNotification('Logged out successfully.');
    navigate('/');
  };

  // Authentication Modal states
  const [isAuthOpen, setIsAuthOpen] = useState(false);
  const [authMode, setAuthMode] = useState('login');
  const [isMasterAdminPromptOpen, setIsMasterAdminPromptOpen] = useState(false);

  // Direct checkout protection for Master Admin
  useEffect(() => {
    if (activePage === 'checkout' && currentUser && currentUser.roles && currentUser.roles.includes('Master Admin')) {
      navigate('/');
      setIsMasterAdminPromptOpen(true);
    }
  }, [activePage, currentUser, navigate]);

  useEffect(() => {
    const handleOpenAuthModal = (e) => {
      if (e.detail && e.detail.mode) {
        setAuthMode(e.detail.mode);
      } else {
        setAuthMode('login');
      }
      setIsAuthOpen(true);
    };
    window.addEventListener('open-auth-modal', handleOpenAuthModal);
    return () => {
      window.removeEventListener('open-auth-modal', handleOpenAuthModal);
    };
  }, []);

  // Checkout Page states (using route/tab instead of modal)

  // Customer Order History – navigate to dedicated page
  const handleOpenOrderHistory = () => {
    if (!currentUser) {
      triggerNotification('Please sign in or sign up to view your order history and track shipments.');
      setAuthMode('login');
      setIsAuthOpen(true);
      return;
    }
    navigate('/my-orders');
  };

  const handleOpenProfile = () => {
    if (!currentUser) {
      triggerNotification('Please sign in to view and manage your profile settings.');
      setAuthMode('login');
      setIsAuthOpen(true);
      return;
    }
    navigate('/profile');
  };

  // Admin Portal states
  const [isAdminOpen, setIsAdminOpen] = useState(false);
  const [adminTab, setAdminTab] = useState('catalog'); // 'catalog' | 'orders' | 'logs'
  const [adminProducts, setAdminProducts] = useState([]);
  const [adminLogs, setAdminLogs] = useState([]);
  const [adminOrders, setAdminOrders] = useState([]);
  const [expandedOrderId, setExpandedOrderId] = useState(null);
  const [adminOrderUpdating, setAdminOrderUpdating] = useState(null);

  // Create product form state
  const [adminProductForm, setAdminProductForm] = useState({
    title: '',
    sku: '',
    category_id: '1',
    price: '',
    description: '',
    short_description: '',
    specs_label: '',
    specs_value: ''
  });

  const fetchAdminProducts = async () => {
    try {
      const res = await axios.get(`${API_BASE_URL}/products?t=${Date.now()}`);
      setAdminProducts(res.data.products || []);
    } catch (e) { }
  };

  const fetchAdminOrders = async () => {
    try {
      const token = localStorage.getItem('token');
      const res = await axios.get(`${API_BASE_URL}/orders/admin/all`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      setAdminOrders(res.data.orders || []);
    } catch (e) { console.error('Failed to fetch admin orders:', e); }
  };

  const handleUpdateOrderAdmin = async (orderId, updates) => {
    setAdminOrderUpdating(orderId);
    try {
      const token = localStorage.getItem('token');
      await axios.put(`${API_BASE_URL}/orders/${orderId}/status`, updates, {
        headers: { Authorization: `Bearer ${token}` }
      });
      triggerNotification('Order updated successfully!');
      await fetchAdminOrders();
    } catch (err) {
      triggerNotification(err.response?.data?.message || 'Failed to update order.');
    } finally {
      setAdminOrderUpdating(null);
    }
  };

  const fetchAdminLogs = async () => {
    try {
      const token = localStorage.getItem('token');
      if (!token) return;
      const res = await axios.get(`${API_BASE_URL}/auth/admin/logs`, {
        headers: { 'Authorization': `Bearer ${token}` }
      });
      setAdminLogs(res.data.logs || []);
    } catch (e) { }
  };

  useEffect(() => {
    if (isAdminOpen) {
      fetchAdminProducts();
      fetchAdminLogs();
    }
  }, [isAdminOpen]);

  const handleCreateProduct = async (e) => {
    e.preventDefault();
    const { title, sku, category_id, price, description, short_description, specs_label, specs_value } = adminProductForm;
    if (!title || !sku || !price) {
      triggerNotification("Product Title, SKU and Price are required.");
      return;
    }

    try {
      const token = localStorage.getItem('token');
      if (!token) throw new Error("Auth token not found.");

      const specs = [];
      if (specs_label && specs_value) {
        specs.push({ label: specs_label, value: specs_value });
      }

      const payload = {
        category_id: parseInt(category_id),
        sku,
        title,
        description,
        short_description,
        specifications: specs,
        variants: [
          {
            sku: `${sku}-500ML`,
            price: parseFloat(price),
            compare_at_price: parseFloat(price) * 1.5,
            weight_grams: 500,
            stock_quantity: 100
          }
        ]
      };

      const res = await axios.post(`${API_BASE_URL}/products`, payload, {
        headers: {
          'Authorization': `Bearer ${token}`
        }
      });

      const data = res.data;

      triggerNotification(data.message || 'Product created successfully!');
      setAdminProductForm({
        title: '',
        sku: '',
        category_id: '1',
        price: '',
        description: '',
        short_description: '',
        specs_label: '',
        specs_value: ''
      });
      fetchAdminProducts();
      fetchAdminLogs();
    } catch (err) {
      console.error(err);
      const errorMessage = err.response?.data?.message || err.message || 'Failed to create product.';
      triggerNotification(errorMessage);
    }
  };

  const handleDeleteProduct = async (productId) => {
    if (!window.confirm("Are you sure you want to delete this product from the catalog?")) return;

    try {
      const token = localStorage.getItem('token');
      if (!token) throw new Error("Auth token not found.");

      const res = await axios.delete(`${API_BASE_URL}/products/${productId}`, {
        headers: { 'Authorization': `Bearer ${token}` }
      });

      const data = res.data;

      triggerNotification(data.message || 'Product deleted successfully!');
      fetchAdminProducts();
      fetchAdminLogs();
    } catch (err) {
      console.error(err);
      const errorMessage = err.response?.data?.message || err.message || 'Failed to delete product.';
      triggerNotification(errorMessage);
    }
  };

  // Success Notification States
  const [notification, setNotification] = useState('');

  // Scroll to Top visibility state and listener
  const [showScrollTop, setShowScrollTop] = useState(false);

  useEffect(() => {
    const handleScrollVisibility = () => {
      if (window.scrollY > 300) {
        setShowScrollTop(true);
      } else {
        setShowScrollTop(false);
      }
    };

    window.addEventListener('scroll', handleScrollVisibility);
    return () => window.removeEventListener('scroll', handleScrollVisibility);
  }, []);



  const convertPrice = (priceInput, curr) => {
    if (priceInput === undefined || priceInput === null) return '';
    let val;
    if (typeof priceInput === 'number') {
      val = priceInput;
    } else {
      val = parseFloat(priceInput.replace(/[^0-9.]/g, ''));
    }
    if (isNaN(val)) return priceInput;
    const rates = {
      INR: { rate: 1, symbol: '₹' },
      USD: { rate: 0.012, symbol: '$' },
      EUR: { rate: 0.011, symbol: '€' },
      GBP: { rate: 0.0094, symbol: '£' },
      AED: { rate: 0.044, symbol: 'د.إ ' },
      SGD: { rate: 0.016, symbol: 'S$' }
    };
    const config = rates[curr] || rates.INR;
    return `${config.symbol}${(val * config.rate).toFixed(2)}`;
  };

  const productTranslations = {
    en: {
      1: { title: "Super Novel", desc: "BIO-ORBI Super Novel is a 100% organic plant growth supplement that promotes stronger roots, healthier plants, improved flowering, and higher yields. Suitable for all crops, it provides essential nutrients for sustainable and productive farming." },
      2: { title: "Prime", desc: "BIO-ORBI Prime is a liquid biofertilizer enriched with Azotobacter, beneficial bacteria that naturally fix atmospheric nitrogen and improve soil fertility. It promotes stronger root development, healthier plant growth, and increased crop yield while reducing dependence on chemical fertilizers." },
      3: { title: "Plus", desc: "BIO-ORBI Plus is an advanced organic plant growth supplement designed to support vigorous crop growth, improved nutrient uptake, and higher productivity. Its nutrient-rich formulation promotes stronger roots, healthier plants, better flowering, and enhanced yield, making it suitable for a wide range of agricultural crops." },
      4: { title: "Organic Manure", desc: "BIO-ORBI Organic Manure is a premium organic soil conditioner made from natural organic materials that enrich soil fertility and improve crop performance. It enhances soil structure, promotes healthy root growth, increases nutrient availability, and supports sustainable farming practices for better crop yield and quality." }
    }
  };

  const uiTranslations = {
    en: {
      topProducts: "Organic Bhi, Swadeshi Bhi",
      bestSale: "Nature's Finest Products",
      inStock: "In Stock",
      reviews: "Review",
      sku: "SKU",
      brand: "Brand",
      shareItem: "Share Item",
      addToCart: "Add to Cart",
      category: "Category",
      tags: "Tags",
      freeShipping: "Free Shipping",
      freeShippingDesc: "On all orders",
      greatSupport: "Support 24/7",
      greatSupportDesc: "Instant assistance",
      securePayment: "Secure Payment",
      securePaymentDesc: "100% safe checkout",
      moneyBack: "Money-Back Guarantee",
      moneyBackDesc: "30 days guarantee",
      searchPlaceholder: "Search for organic soil product...",
      searchPlaceholderScrolled: "Search...",
      home: "Home",
      aboutUs: "About us",
      ourProducts: "Our Products",
      shop: "Shop",
      knowledgeHub: "Knowledge Hub",
      contact: "Contact",
      bulkOrder: "Bulk Order",
      supportText: "Support",
      signinSignup: "Sign in / Sign up",
      shoppingCart: "Shopping Cart",
      categoryAll: "All Categories",
      categoryFertilizer: "Fertilizers",
      categoryBioFertilizer: "Bio Fertilizers",
      categorySoilConditioner: "Soil Conditioners",
      categoryPestControl: "Pest Control",
      heroTagOrganic: "100% ORGANIC",
      heroTagPure: "PURE | SAFE | EFFECTIVE",
      heroNovelTitleDark: "Nature's Goodness,",
      heroNovelTitleAccent: "Bumper Harvest.",
      heroNovelSubtitle: "100% Organic Plant Growth Supplements",
      heroShopNow: "Shop Now",
      heroNovelBadge1: "Boosts Soil Health",
      heroNovelBadge2: "Enhances Root Growth",
      heroNovelBadge3: "Improves Crop Yield",
      heroNovelBadge4: "Safe for Soil & Future",
      heroPrimeTitleScript: "Nourish Today,",
      heroPrimeTitleBold: "HARVEST TOMORROW.",
      heroPrimeBrandProduct: "SUPER PRIME",
      heroPrimeDescriptor: "POTASSIUM MOBILIZING BACTERIA LIQUID BIOFERTILIZER",
      heroPrimeBadge1: "ENRICHES SOIL NATURALLY",
      heroPrimeBadge2: "STRONGER ROOTS BETTER GROWTH",
      heroPrimeBadge3: "HIGHER YIELD BETTER QUALITY",
      heroPrimeBadge4: "BOOSTS PLANT IMMUNITY",
      heroNutriLabel: "NOURISH SOIL. GROW ORGANIC.",
      heroNutriTitleLine1: "PURE NUTRITION.",
      heroNutriTitleLine2: "BETTER TOMORROW.",
      heroNutriSubtitle: "100% Organic fertilizers for healthier soil, stronger plants and higher yields.",
      heroNutriBadge1: "100% Organic Pure & Natural",
      heroNutriBadge2: "Improves Soil Health",
      heroNutriBadge3: "Better Growth Higher Yield",
      heroNutriBadge4: "Safe for Env & Future",
      summerSaleLabel: "SUMMER SALE",
      summerSaleDiscount: "37% OFF",
      summerSaleDesc: "Free on all your order, Free Shipping and 30 money-back guarantee",
      productSpotlightTitle: "Product Spotlight",
      premiumRange: "The Premium Range",
      shopByPestTitle: "SHOP BY PEST & DISEASE",
      cropProblemsDesc: "Find solutions for your crop problems.",
      viewAll: "View All",
      cropEnrichedManure: "Enriched Organic Manure",
      cropManure: "Organic Manure",
      cropPlus: "Bio Orbi Plus",
      cropPrime: "Bio Orbi Prime",
      cropSuperNovel: "Bio Orbi Super Novel",
      cropVermicompost: "Vermicompost",
      subOrganicSol: "Organic Sol.",
      subOrganicBoost: "Organic Boost",
      subOrganicNitrogen: "Organic Nitrogen",
      subOrganicGrowth: "Organic Growth",
      subSoilHealth: "Soil Health",
      farmingWithOrbifert: "FARMING WITH ORBIFERT",
      bioPestControl: "Organic Bio-Fertilizers",
      hotSale: "HOT SALE",
      promo1Text: "Save 37% on Pure Liquid Bio-Fertilizer Packs",
      newRelease: "NEW RELEASE",
      promo2Text: "100% Organic NPK & Soil Enhancer Formula",
      bestPrice: "BEST PRICE",
      promo3Text: "Premium Compost & Natural Vermicompost Combo",
      featuredProductsTitle: "Our Featured Products",
      clientTestimonials: "CLIENT TESTIMONIALS",
      whatCustomersSay: "What Our Customers Say",
      knowledgeHubTitle: "Latest Insights & Blog",
      readMore: "Read More",
      videoTitle: "We're the Best Organic Products in the World",
      subscribeNewsletter: "Subscribe to our Newsletter",
      subscribeDesc: "Pellentesque eu nibh eget mauris congue mattis nec tellus. Phasellus imperdiet elit eu magna dictum.",
      yourEmailAddress: "Your email address",
      subscribe: "Subscribe",
      subscribed: "Subscribed!",
      myAccount: "My Account",
      orderHistory: "Order History",
      shoppingCartLabel: "Shopping Cart",
      wishlist: "Wishlist",
      helps: "Helps",
      faqs: "FAQs",
      termsCondition: "Terms & Condition",
      privacyPolicy: "Privacy Policy",
      proxy: "Proxy",
      product: "Product",
      trackOrder: "Track Order",
      downloadMobileApp: "Download Mobile App",
      downloadOnAppStore: "Download on the",
      appStore: "App Store",
      googlePlay: "Google Play",
      allRightsReserved: "All Rights Reserved"
    },
    hi: {
      topProducts: "शीर्ष उत्पाद",
      bestSale: "सर्वश्रेष्ठ बिक्री",
      inStock: "स्टॉक में है",
      reviews: "समीक्षा",
      sku: "SKU",
      brand: "ब्रांड",
      shareItem: "शेयर करें",
      addToCart: "कार्ट में जोड़ें",
      category: "श्रेणी",
      tags: "टैग",
      freeShipping: "निःशुल्क शिपिंग",
      freeShippingDesc: "छूट के साथ मुफ्त शिपिंग",
      greatSupport: "बेहतरीन सहायता 24/7",
      greatSupportDesc: "तत्काल संपर्क",
      securePayment: "100% सुरक्षित भुगतान",
      securePaymentDesc: "हम आपके पैसे की सुरक्षा सुनिश्चित करते हैं",
      moneyBack: "मनी-बैक गारंटी",
      moneyBackDesc: "30 दिन मनी-बैक",
      searchPlaceholder: "जैविक उत्पाद खोजें...",
      searchPlaceholderScrolled: "खोजें...",
      home: "होम",
      aboutUs: "हमारे बारे में",
      ourProducts: "हमारे उत्पाद",
      shop: "दुकान",
      knowledgeHub: "ज्ञान केंद्र",
      contact: "संपर्क",
      bulkOrder: "बल्क ऑर्डर",
      signinSignup: "साइन इन / साइन अप",
      shoppingCart: "शॉपिंग कार्ट",
      heroTagOrganic: "100% जैविक",
      heroTagPure: "शुद्ध | सुरक्षित | प्रभावी",
      heroNovelTitleDark: "प्रकृति की अच्छाई,",
      heroNovelTitleAccent: "भरपूर फसल.",
      heroNovelSubtitle: "100% जैविक पौधा विकास उत्पाद",
      heroShopNow: "अभी खरीदें",
      shopByPestTitle: "कीट और रोग द्वारा खरीदें",
      cropProblemsDesc: "अपनी फसल समस्याओं के समाधान खोजें",
      viewAll: "सभी देखें",
      featuredProductsTitle: "हमारे प्रमुख उत्पाद",
      clientTestimonials: "ग्राहक प्रशंसापत्र",
      whatCustomersSay: "हमारे ग्राहक क्या कहते हैं",
      readMore: "और पढ़ें",
      summerSaleLabel: "गर्मी सेल",
      summerSaleDiscount: "37% छूट",
      subscribe: "सदस्यता लें",
      subscribed: "सदस्य हो गए!",
      productSpotlightTitle: "उत्पाद स्पॉटलाइट",
      premiumRange: "प्रीमियम श्रेणी",
      allRightsReserved: "सर्वाधिकार सुरक्षित"
    },
    ta: {
      topProducts: "சிறந்த தயாரிப்புகள்",
      bestSale: "சிறந்த விற்பனை",
      inStock: "கையிருப்பில் உள்ளது",
      reviews: "மதிப்பீடு",
      sku: "SKU",
      brand: "பிராண்ட்",
      shareItem: "பகிர்",
      addToCart: "கார்ட்டில் சேர்",
      category: "வகை",
      tags: "குறிச்சொற்கள்",
      freeShipping: "இலவச ஷிப்பிங்",
      freeShippingDesc: "தள்ளுபடியுடன் இலவச ஷிப்பிங்",
      greatSupport: "சிறந்த ஆதரவு 24/7",
      greatSupportDesc: "உடனடி தொடர்பு",
      securePayment: "100% பாதுகாப்பான பேமென்ட்",
      securePaymentDesc: "உங்கள் பணம் பாதுகாப்பாக உள்ளது",
      moneyBack: "பணம் திரும்ப உத்தரவாதம்",
      moneyBackDesc: "30 நாட்கள் பணம் திரும்ப",
      searchPlaceholder: "இயற்கை தயாரிப்புகளை தேடுங்கள்...",
      searchPlaceholderScrolled: "தேடு...",
      home: "முகப்பு",
      aboutUs: "எங்களைப் பற்றி",
      ourProducts: "எங்கள் தயாரிப்புகள்",
      shop: "கடை",
      knowledgeHub: "அறிவு மையம்",
      contact: "தொடர்பு",
      bulkOrder: "மொத்த ஆர்டர்",
      signinSignup: "உள்நுழை / பதிவு",
      shoppingCart: "கார்ட்",
      heroTagOrganic: "100% இயற்கையானது",
      heroNovelTitleDark: "இயற்கையின் நல்லமை,",
      heroNovelTitleAccent: "ஞெறி அறுவடை.",
      heroNovelSubtitle: "100% இயற்கை தாவர வளர்ச்சி பொருட்கள்",
      heroShopNow: "இப்போது வாங்கு",
      viewAll: "அனைத்தும் பார்க்க",
      featuredProductsTitle: "எங்கள் சிறப்பு தயாரிப்புகள்",
      clientTestimonials: "கிளைங்கர் சாட்சிகள்",
      whatCustomersSay: "அல்ஜர்கள் என்ன சொல்கிறார்கள்",
      readMore: "மேலும் படிக்க",
      summerSaleLabel: "கோடை விற்பனை",
      summerSaleDiscount: "37% தள்ளுபடி",
      subscribe: "சேர்திகோள்க",
      subscribed: "சேர்ந்துவிட்டீர்கள்!",
      productSpotlightTitle: "தயாரிப்பு ஸ்போட்லைட்",
      premiumRange: "ப்ரிமியம் தொடர்",
      allRightsReserved: "அனைத்து உரிமைகள் மறுக்கப்பட்டன"
    },
    kn: {
      topProducts: "ಉನ್ನತ ಉತ್ಪನ್ನಗಳು",
      bestSale: "ಅತ್ಯುತ್ತಮ ಮಾರಾಟ",
      inStock: "ಸ್ಟಾಕ್‌ನಲ್ಲಿ ಇದೆ",
      reviews: "ವಿಮರ್ಶೆ",
      sku: "SKU",
      brand: "ಬ್ರ್ಯಾಂಡ್",
      shareItem: "ಹಂಚಿಕೊಳ್ಳಿ",
      addToCart: "ಕಾರ್ಟ್‌ಗೆ ಸೇರಿಸಿ",
      category: "ವರ್ಗ",
      tags: "ಟ್ಯಾಗ್‌ಗಳು",
      freeShipping: "ಉಚಿತ ಶಿಪ್ಪಿಂಗ್",
      freeShippingDesc: "ರಿಯಾಯಿತಿಯೊಂದಿಗೆ ಉಚಿತ ಶಿಪ್ಪಿಂಗ್",
      greatSupport: "ಉತ್ತಮ ಬೆಂಬಲ 24/7",
      greatSupportDesc: "ತಕ್ಷಣ ಸಂಪರ್ಕ",
      securePayment: "100% ಸುರಕ್ಷಿತ ಪಾವತಿ",
      securePaymentDesc: "ನಿಮ್ಮ ಹಣ ಸುರಕ್ಷಿತ",
      moneyBack: "ಹಣ ಹಿಂದಿರುಗಿಸುವ ಖಾತ್ರಿ",
      moneyBackDesc: "30 ದಿನ ಹಣ ಹಿಂದಿರುಗಿಸುವಿಕೆ",
      searchPlaceholder: "ಸಾವಯವ ಉತ್ಪನ್ನಗಳನ್ನು ಹುಡುಕಿ...",
      searchPlaceholderScrolled: "ಹುಡುಕಿ...",
      home: "ಮನೆ",
      aboutUs: "ನಮ್ಮ ಬಗ್ಗೆ",
      ourProducts: "ನಮ್ಮ ಉತ್ಪನ್ನಗಳು",
      shop: "ಅಂಗಡಿ",
      knowledgeHub: "ಜ್ಞಾನ ಕೇಂದ್ರ",
      contact: "ಸಂಪರ್ಕ",
      signinSignup: "ಸೈನ್ ಇನ್ / ಸೈನ್ ಅಪ್",
      viewAll: "ಸರ್ವವನ್ನು ನೋಡಿ",
      featuredProductsTitle: "ನಮ್ಮ ಪ್ರಮುಖ ಉತ್ಪನ್ನಗಳು",
      readMore: "ಮೆರೆ ಓದಿ",
      allRightsReserved: "ಸರ್ವ ಹಕ್ಕುಗಳು ಮೀಸಲು"
    },
    te: {
      topProducts: "అగ్ర ఉత్పత్తులు",
      bestSale: "అత్యుత్తమ అమ్మకం",
      inStock: "స్టాక్‌లో ఉంది",
      reviews: "సమీక్ష",
      sku: "SKU",
      brand: "బ్రాండ్",
      shareItem: "పంచుకోండి",
      addToCart: "కార్ట్‌కి జోడించు",
      category: "వర్గం",
      tags: "ట్యాగ్‌లు",
      freeShipping: "ఉచిత షిప్పింగ్",
      freeShippingDesc: "తగ్గింపుతో ఉచిత షిప్పింగ్",
      greatSupport: "అద్భుతమైన మద్దతు 24/7",
      greatSupportDesc: "తక్షణం సంప్రదింపు",
      securePayment: "100% సురక్షిత చెల్లింపు",
      securePaymentDesc: "మీ డబ్బు సురక్షితంగా ఉంది",
      moneyBack: "మనీ-బ్యాక్ గ్యారంటీ",
      moneyBackDesc: "30 రోజుల మనీ-బ్యాక్",
      searchPlaceholder: "సేంద్రియ ఉత్పత్తులను వెతకండి...",
      searchPlaceholderScrolled: "వెతకండి...",
      home: "హోమ్",
      aboutUs: "మా గురించి",
      ourProducts: "మా ఉత్పత్తులు",
      shop: "షాప్",
      knowledgeHub: "జ్ఞాన కేంద్రం",
      contact: "సంప్రదింపు",
      signinSignup: "సైన్ ఇన్ / సైన్ అప్",
      viewAll: "అన్నీ చూడండి",
      featuredProductsTitle: "మా ప్రముఖ ఉత్పత్తులు",
      readMore: "ఇంకా చదవండి",
      allRightsReserved: "అన్ని హక్కులు ముద్రించబడ్డాయి"
    },
    ml: {
      topProducts: "മികച്ച ഉൽപ്പന്നങ്ങൾ",
      bestSale: "മികച്ച വിൽപ്പന",
      inStock: "സ്റോക്കിൽ ഉണ്ട്",
      reviews: "അവലോകനം",
      sku: "SKU",
      brand: "ബ്രാൻഡ്",
      shareItem: "പങ്കിടുക",
      addToCart: "കാർട്ടിൽ ചേർക്കുക",
      category: "വിഭാഗം",
      tags: "ടാഗുകൾ",
      freeShipping: "സൗജന്യ ഷിപ്പിംഗ്",
      freeShippingDesc: "കിഴവുള്ള സൗജന്യ ഷിപ്പിംഗ്",
      greatSupport: "മികച്ച സഹായം 24/7",
      greatSupportDesc: "ഉടനടി ബന്ധപ്പെടൽ",
      securePayment: "100% സുരക്ഷിത പേമെന്റ്",
      securePaymentDesc: "നിങ്ങളുടെ പണം സുരക്ഷിതം",
      moneyBack: "മണി-ബാക്ക് ഗ്യാരന്റി",
      moneyBackDesc: "30 ദിവസം മണി-ബാക്ക്",
      searchPlaceholder: "ഓർഗാനിക് ഉൽപ്പന്നങ്ങൾ തിരയൂ...",
      searchPlaceholderScrolled: "തിരയൂ...",
      home: "ഹോം",
      aboutUs: "\u0d1eങ്ങളെക്കുറിച്ച്",
      ourProducts: "ഞങ്ങളുടെ ഉൽപ്പന്നങ്ങൾ",
      shop: "ഷോപ്പ്",
      knowledgeHub: "അറിവ് കേന്ദ്രം",
      contact: "ബന്ധപ്പെടുക",
      signinSignup: "സൈൻ ഇൻ / സൈൻ അപ്പ്",
      viewAll: "എല്ലാം കാണുക",
      featuredProductsTitle: "ഞങ്ങളുടെ പ്രധാന ഉൽപ്പന്നങ്ങൾ",
      readMore: "കൂടുതൽ വായിക്കുക",
      allRightsReserved: "സര്വ്വാധികാരങ്ങളും സംരക്ഷിച്ചിരിക്കുന്നു"
    },
    de: {
      topProducts: "TOP-PRODUKTE",
      bestSale: "Bestseller",
      inStock: "Auf Lager",
      reviews: "Bewertung",
      sku: "SKU",
      brand: "Marke",
      shareItem: "Teilen",
      addToCart: "In den Warenkorb",
      category: "Kategorie",
      tags: "Tags",
      freeShipping: "Kostenloser Versand",
      freeShippingDesc: "Kostenloser Versand mit Rabatt",
      greatSupport: "Hervorragender Support 24/7",
      greatSupportDesc: "Sofortiger Kontakt",
      securePayment: "100% Sichere Zahlung",
      securePaymentDesc: "Wir garantieren die Sicherheit Ihres Geldes",
      moneyBack: "Geld-zur\u00fcck-Garantie",
      moneyBackDesc: "30 Tage Geld zur\u00fcck",
      searchPlaceholder: "Bio-Produkte suchen...",
      searchPlaceholderScrolled: "Suchen...",
      home: "Startseite",
      aboutUs: "\u00dcber uns",
      ourProducts: "Unsere Produkte",
      shop: "Shop",
      knowledgeHub: "Wissenszentrum",
      contact: "Kontakt",
      bulkOrder: "Gro\u00dfbestellung",
      signinSignup: "Anmelden / Registrieren",
      shoppingCart: "Warenkorb",
      heroTagOrganic: "100% BIO",
      heroNovelTitleDark: "Die G\u00fcte der Natur,",
      heroNovelTitleAccent: "Reiche Ernte.",
      heroNovelSubtitle: "100% Organische Pflanzenwachstumsmittel",
      heroShopNow: "Jetzt kaufen",
      viewAll: "Alle anzeigen",
      featuredProductsTitle: "Unsere Ausgestellten Produkte",
      clientTestimonials: "KUNDENSTIMMEN",
      whatCustomersSay: "Was unsere Kunden sagen",
      readMore: "Mehr lesen",
      summerSaleLabel: "SOMMERSCHLUSSVERKAUF",
      summerSaleDiscount: "37% RABATT",
      subscribe: "Abonnieren",
      subscribed: "Abonniert!",
      productSpotlightTitle: "Produktrampenlicht",
      premiumRange: "Das Premium-Sortiment",
      allRightsReserved: "Alle Rechte vorbehalten"
    }
  };

  const t = (key) => {
    const langTrans = uiTranslations[selectedLang] || uiTranslations['en'];
    return langTrans[key] || uiTranslations['en'][key] || key;
  };

  const triggerNotification = (message) => {
    setNotification(message);
    setTimeout(() => {
      setNotification('');
    }, 3000);
  };

  const handleAddToCart = (item, quantity = 1) => {
    let prod = item;
    if (typeof item === 'string') {
      prod = {
        id: item,
        title: item,
        price: 140.99,
        image: "/products/bio-orbi-super-novel.png"
      };
      if (item.includes("Vermicompost")) {
        prod.price = 120;
        prod.image = "/products/Vermicompost.png";
      } else if (item.includes("Enriched Organic Manure")) {
        prod.price = 120;
        prod.image = "/products/Enriched Organic Manure.png";
      } else if (item.includes("Organic Manure")) {
        prod.price = 120;
        prod.image = "/products/Organic Manure.png";
      } else if (item.includes("Super Plus") || item.includes("Plus")) {
        prod.image = "/products/bio-orbi-plus.png";
      } else if (item.includes("Prime")) {
        prod.image = "/products/bio-orbi-prime.png";
      } else if (item.includes("Super Novel")) {
        prod.image = "/products/bio-orbi-super-novel.png";
      }
    } else {
      const defaultVariant = (item.variants && item.variants.length > 0) ? item.variants[0] : {};
      const resolvedVariantId = item.variant_id || defaultVariant.id;
      prod = {
        id: resolvedVariantId ? `${item.id}-${resolvedVariantId}` : item.id,
        variant_id: resolvedVariantId,
        sku: item.sku || defaultVariant.sku || '',
        title: item.title || item.name,
        price: typeof item.newPrice === 'string' ? parseFloat(item.newPrice.replace(/[^0-9.]/g, '')) : (item.price || defaultVariant.price || 140.99),
        image: item.image || "/products/Super Novel.png"
      };
    }

    setCartItems(prevItems => {
      const existing = prevItems.find(i => i.id === prod.id);
      if (existing) {
        return prevItems.map(i => i.id === prod.id ? { ...i, qty: i.qty + quantity } : i);
      }
      return [...prevItems, { ...prod, qty: quantity }];
    });
    triggerNotification(`"${prod.title}" added to cart!`);
  };

  const handleAddToWishlist = (item) => {
    let prod = item;
    if (typeof item === 'string') {
      prod = {
        id: item,
        title: item,
        price: 140.99,
        image: "/products/bio-orbi-super-novel.png"
      };
      if (item.includes("Vermicompost")) {
        prod.price = 120;
        prod.image = "/products/Vermicompost.png";
      } else if (item.includes("Enriched Organic Manure")) {
        prod.price = 120;
        prod.image = "/products/Enriched Organic Manure.png";
      } else if (item.includes("Organic Manure")) {
        prod.price = 120;
        prod.image = "/products/Organic Manure.png";
      } else if (item.includes("Super Plus") || item.includes("Plus")) {
        prod.image = "/products/bio-orbi-plus.png";
      } else if (item.includes("Prime")) {
        prod.image = "/products/bio-orbi-prime.png";
      } else if (item.includes("Super Novel")) {
        prod.image = "/products/bio-orbi-super-novel.png";
      }
    } else {
      prod = {
        id: item.id,
        title: item.title || item.name,
        price: typeof item.newPrice === 'string' ? parseFloat(item.newPrice.replace(/[^0-9.]/g, '')) : (item.price || 140.99),
        image: item.image || "/products/bio-orbi-super-novel.png"
      };
    }

    setWishlistItems(prevItems => {
      const existing = prevItems.find(i => i.id === prod.id);
      if (existing) {
        triggerNotification(`"${prod.title}" is already in wishlist!`);
        return prevItems;
      }
      triggerNotification(`"${prod.title}" added to wishlist!`);
      return [...prevItems, prod];
    });
  };

  const handleRemoveFromCart = (id) => {
    setCartItems(prev => prev.filter(item => item.id !== id));
  };

  const handleRemoveFromWishlist = (id) => {
    setWishlistItems(prev => prev.filter(item => item.id !== id));
  };

  const handleCartQtyChange = (id, delta) => {
    setCartItems(prev => prev.map(item => {
      if (item.id === id) {
        const newQty = item.qty + delta;
        return { ...item, qty: Math.max(1, newQty) };
      }
      return item;
    }));
  };

  const closeDrawers = () => {
    setIsCartOpen(false);
    setIsWishlistOpen(false);
  };

  // 1. Hero Section Banner Slider
  const heroBanners = [
    {
      img: '/hero-section-banner/banner new.png',
      variant: 'gem-gov',
      link: 'https://gem.gov.in/',
      logo: '/hero-section-banner/GeM-logo.webp',
      badges: ['Improves Soil\nHealth', 'Enhances Crop\nYield', 'Safe, Effective\n& Sustainable', 'Govt. Patent\nFiled Tech']
    },
    {
      img: '/hero-section-banner/orbifert banner 1.png',
      variant: 'novel',
      titleDark: "Nature's Goodness,",
      titleAccent: "Bumper Harvest.",
      subtitle: "Reviving Soil, Rewarding Farmers",
      badges: ['Boosts Soil\nHealth', 'Enhances Root\nGrowth', 'Improves\nCrop Yield', 'Safe for Soil,\nSafe for Future']
    },
    {
      img: '/hero-section-banner/orbifert banner2.png',
      variant: 'prime',
      scriptLine: "Nourish Today,",
      boldLine: "HARVEST TOMORROW.",
      brand: "BIO-ORBI",
      brandProduct: "SUPER PRIME",
      descriptor: "POTASSIUM MOBILIZING BACTERIA LIQUID BIOFERTILIZER",
      badges: ['ENRICHES SOIL\nNATURALLY', 'STRONGER ROOTS\nBETTER GROWTH', 'HIGHER YIELD\nBETTER QUALITY', 'BOOSTS PLANT\nIMMUNITY']
    },
    {
      img: '/hero-section-banner/orbifert banner3.png',
      variant: 'nutrition',
      label: 'NOURISH SOIL. GROW ORGANIC.',
      titleLine1: 'PURE NUTRITION.',
      titleLine2: 'BETTER TOMORROW.',
      subtitle: "NOURISH SOIL. GROW ORGANIC.",
      badges: ['100% Organic\nPure & Natural', 'Improves\nSoil Health', 'Better Growth\nHigher Yield', 'Safe for Environment\n& Future']
    },
    {
      img: '/hero-section-banner/banner 5.png',
      variant: 'trust',
      link: 'https://gem.gov.in/',
      titleDark: "Healthy Soil. Stronger Crops.",
      titleAccent: "Better Tomorrow.",
      subtitle: "A Trusted Brand Since 1990. From Seed To Harvest, We Care.",
      badges: ['Premium Quality\nProducts', 'Sustainable Farming\nSolutions', 'Dedicated Expert\nSupport']
    }
  ];
  const [currentHeroIndex, setCurrentHeroIndex] = useState(0);
  const [isHeroHovered, setIsHeroHovered] = useState(false);

  useEffect(() => {
    if (isHeroHovered) return;
    const timer = setInterval(() => {
      setCurrentHeroIndex(prev => (prev + 1) % heroBanners.length);
    }, 8000);
    return () => clearInterval(timer);
  }, [heroBanners.length, isHeroHovered]);

  const [activeTopProduct, setActiveTopProduct] = useState(null);
  const [productQuantities, setProductQuantities] = useState({ 1: 5, 2: 1, 3: 1, 4: 1 });
  // Start with empty arrays – DB fetch below will populate them
  const [topProductsList, setTopProductsList] = useState([]);
  const [spotlightProductsList, setSpotlightProductsList] = useState([]);

  // Callback for admin to directly update landing page product lists without navigation
  const handleStorefrontLayoutSaved = (topIds, spotIds) => {
    setTopProductsList(topIds.map(Number));
    setSpotlightProductsList(spotIds.map(Number));
  };

  const handleQtyChange = (prodId, delta) => {
    setProductQuantities(prev => ({
      ...prev,
      [prodId]: Math.max(1, (prev[prodId] || 1) + delta)
    }));
  };

  // Re-fetch from DB when returning to home (after admin navigation)
  // This is the single source of truth — works across all devices
  const fetchStorefrontLayout = async () => {
    // Set static featured layout lists from local DB ids
    setTopProductsList([14, 15, 16, 19, 17, 13]);
    setSpotlightProductsList([14, 15, 16]);
  };

  useEffect(() => {
    // Fetch storefront layout from DB on home page load
    fetchStorefrontLayout();
    // Re-fetch latest products from DB
    SearchService.getAllProducts().then(data => {
      if (data && data.length > 0) {
        setDbProducts(data);
      }
    }).catch(err => {
      console.warn('Failed to fetch products for landing page:', err);
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // When dbProducts loads, sync product lists — defaults pick real DB products if no layout set yet
  useEffect(() => {
    if (dbProducts.length === 0) return;
    // Only default to first N products if no DB layout has been loaded yet
    if (topProductsList.length === 0) {
      setTopProductsList(dbProducts.slice(0, 4).map(p => p.id));
    }
    if (spotlightProductsList.length === 0) {
      setSpotlightProductsList(dbProducts.slice(0, 3).map(p => p.id));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dbProducts]);

  const resolvedTopProducts = React.useMemo(() => {
    if (dbProducts.length === 0 || topProductsList.length === 0) return [];
    return topProductsList
      .map(id => {
        const found = dbProducts.find(p => Number(p.id) === Number(id));
        if (!found) return null; // skip IDs not in DB

        const baseVariant = found.variants?.[0] || {};
        const priceNum = parseFloat(found.starting_price || baseVariant.price || found.price || 170);
        const oldPriceNum = parseFloat(baseVariant.compare_at_price || (priceNum * 1.5));
        const discountVal = Math.round(((oldPriceNum - priceNum) / oldPriceNum) * 100);
        const firstImage = (found.images && found.images.length > 0) ? found.images[0] : '/img/placeholder.png';

        return {
          id: Number(found.id),
          title: found.title || found.name || 'Product',
          status: 'In Stock',
          rating: (found.title || found.name || '').toLowerCase().includes('super novel') ? 4.5 : 4.0,
          reviewsCount: getProductReviewsCount(found.title || found.name),
          sku: found.sku || baseVariant.sku || `ORB-${found.id}`,
          oldPrice: `₹${oldPriceNum.toFixed(2)}`,
          newPrice: `₹${priceNum.toFixed(2)}`,
          priceRaw: priceNum,
          discount: `${discountVal}% Off`,
          desc: found.short_description || found.description || '',
          category: found.category_name || found.category || 'Organic',
          tags: (found.tags && found.tags.length > 0) ? found.tags : ['Organic', 'Natural'],
          image: firstImage
        };
      })
      .filter(Boolean); // remove nulls (not found in DB)
  }, [topProductsList, dbProducts]);

  const resolvedSpotlightProducts = React.useMemo(() => {
    if (dbProducts.length === 0 || spotlightProductsList.length === 0) return [];
    return spotlightProductsList
      .map(id => {
        const found = dbProducts.find(p => Number(p.id) === Number(id));
        if (!found) return null; // skip IDs not in DB

        const baseVariant = found.variants?.[0] || {};
        const priceNum = parseFloat(found.starting_price || baseVariant.price || found.price || 120);
        const firstImage = (found.images && found.images.length > 0) ? found.images[0] : '/img/placeholder.png';

        return {
          id: Number(found.id),
          title: found.title || found.name || 'Product',
          desc: found.short_description || found.description || '',
          price: priceNum,
          image: firstImage,
          rating: (found.title || found.name || '').toLowerCase().includes('super novel') ? 4.5 : 4.0
        };
      })
      .filter(Boolean);
  }, [spotlightProductsList, dbProducts]);

  // 3. Featured Products Slider Carousel
  const resolvedFeaturedProducts = React.useMemo(() => {
    if (dbProducts.length === 0) {
      // Fallback/Initial items matching the desired 5 products in UI
      return [
        { id: 14, category: "BIO FERTILIZERS", name: "BIO-ORBI Super Novel", price: 1417.50, compare_price: 1417.50, discount: "", image: "/products/bio-orbi-super-novel.png", rating: 4.5 },
        { id: 15, category: "BIO FERTILIZERS", name: "BIO ORBI Super", price: 190.00, compare_price: 320.00, discount: "41% off", image: "/products/bio-orbi-super.png", rating: 4.0 },
        { id: 16, category: "BIO FERTILIZERS", name: "BIO ORBI Super Prime", price: 400.00, compare_price: 600.00, discount: "33% off", image: "/products/bio-orbi-super-prime.png", rating: 4.0 },
        { id: 19, category: "PLANT GROWTH PROMOTERS", name: "Bio Orbi Prime", price: 160.00, compare_price: 400.00, discount: "60% off", image: "/products/bio-orbi-prime.png", rating: 4.0 },
        { id: 17, category: "FERTILIZERS", name: "BIO ORBI Super Plus", price: 290.00, compare_price: 420.00, discount: "31% off", image: "/products/bio-orbi-super-plus.png", rating: 4.0 },
        { id: 13, category: "FERTILIZERS", name: "BIO ORBI Plus", price: 230.00, compare_price: 460.00, discount: "50% off", image: "/products/bio-orbi-plus.png", rating: 4.0 }
      ];
    }
    // Sort by custom product order sequence weight
    const sorted = [...dbProducts].sort((a, b) => {
      return getProductOrderWeight(a.title || a.name) - getProductOrderWeight(b.title || b.name);
    });
    return sorted.map(found => {
      const baseVariant = found.variants?.[0] || {};
      const priceNum = parseFloat(found.starting_price || baseVariant.price || found.price || 140.99);
      const comparePriceNum = parseFloat(baseVariant.compare_at_price || found.compare_price || priceNum * 1.5);
      const firstImage = (found.images && found.images.length > 0) ? found.images[0] : '/img/placeholder.png';
      const categoryName = found.category?.name || "BIO FERTILIZERS";
      const discountText = comparePriceNum > priceNum ? `${Math.round((1 - priceNum / comparePriceNum) * 100)}% off` : '';
      const isSuperNovel = (found.title || found.name || '').toLowerCase().includes('super novel');
      return {
        id: Number(found.id),
        category: categoryName.toUpperCase(),
        name: found.title || found.name || 'Product',
        price: priceNum,
        compare_price: comparePriceNum,
        discount: discountText,
        image: firstImage,
        rating: isSuperNovel ? 4.5 : 4.0,
        isSuperNovel
      };
    });
  }, [dbProducts]);

  const getItemsPerView = () => {
    if (window.innerWidth <= 768) return 1;
    if (window.innerWidth <= 1024) return 3;
    return 5;
  };

  const getPestItemsPerView = () => {
    if (window.innerWidth <= 576) return 1;
    if (window.innerWidth <= 1024) return 2;
    return 4;
  };

  const [featuredOffset, setFeaturedOffset] = useState(0);
  const [itemsPerView, setItemsPerView] = useState(getItemsPerView());

  const [pestOffset, setPestOffset] = useState(0);
  const [pestItemsPerView, setPestItemsPerView] = useState(getPestItemsPerView());

  useEffect(() => {
    const handleResize = () => {
      setItemsPerView(getItemsPerView());
      setPestItemsPerView(getPestItemsPerView());
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const handleNextFeatured = () => {
    setFeaturedOffset(prev => Math.min(prev + 1, resolvedFeaturedProducts.length - itemsPerView));
  };

  const handlePrevFeatured = () => {
    setFeaturedOffset(prev => Math.max(prev - 1, 0));
  };

  const pestSolutions = [
    { title: "Late Blight", sub: "Foliar Blights", img: "/diseases/late_blight.png" },
    { title: "Powdery Mildew", sub: "Mildews", img: "/diseases/powdery_mildew.png" },
    { title: "Leaf Spot", sub: "Foliar Spots", img: "/diseases/leaf_spot.png" },
    { title: "Aphids", sub: "Pests & Vectors", img: "/diseases/aphids.png" },
    { title: "Root Rot", sub: "Root Diseases", img: "/diseases/root_rot.png" },
    { title: "Rust", sub: "Fungus & Rusts", img: "/diseases/rust.png" }
  ];

  const handleNextPest = () => {
    setPestOffset(prev => Math.min(prev + 1, pestSolutions.length - pestItemsPerView));
  };

  const handlePrevPest = () => {
    setPestOffset(prev => Math.max(prev - 1, 0));
  };

  // 4. Testimonials Slider State (Seamless Infinite Loop)
  const [currentTestimonialIndex, setCurrentTestimonialIndex] = useState(0);
  const [noTransition, setNoTransition] = useState(false);

  const testimonials = [
    {
      text: "Our department procured BIO-ORBI Super Novel for state-wide distribution across five districts. The result has been phenomenal. Soil tests showed a 25% increase in microbial activity, and farmers reported improved wheat germination rates. The B2B supply logistics and bulk packaging were handled with absolute professionalism.",
      author: "Dr. Rajesh Kumar Singh",
      role: "Joint Director (Procurement), Department of Agriculture & Farmers Welfare, Government of Haryana",
      rating: 5,
      avatar: "/img/avatar_haryana_singh.png"
    },
    {
      text: "Under the soil restoration subsidy scheme, we distributed Super Novel to paddy farmers. Its high concentration and patent-filed organic formulation meant we achieved higher coverage per liter compared to traditional organic supplements. A stellar B2B partner for state agricultural initiatives.",
      author: "Smt. K. Kavitha",
      role: "Director of Agriculture, Department of Agriculture, Government of Andhra Pradesh",
      rating: 5,
      avatar: "/img/avatar_ap_kavitha.png"
    },
    {
      text: "We evaluated BIO-ORBI Super Novel in our dry-land farming trial blocks. Its impact on root development and moisture retention is highly impressive. Doing bulk procurement with Orbifert was seamless; their compliance with government quality standards (MSME/NPOP) is commendable.",
      author: "Shri. Basavaraj Patil",
      role: "Senior Technical Advisor, Department of Agriculture, Government of Karnataka",
      rating: 5,
      avatar: "/img/avatar_karnataka_patil.png"
    },
    {
      text: "Super Novel has proven to be a game-changer for saline soil conditions in Western Rajasthan. As a department, we chose Orbifert because of their robust lab certifications. The bulk supplies delivered to our district hubs met all chemical-free parameters and helped farmers boost yields.",
      author: "Dr. Preeti Sharma",
      role: "Chief Soil Chemist, Department of Agriculture & Soil Conservation, Government of Rajasthan",
      rating: 5,
      avatar: "/img/avatar_rajasthan_sharma.png"
    },
    {
      text: "Procuring BIO-ORBI Super Novel for our organic farming cluster program has yielded great success. It works as an exceptional plant growth promoter. The B2B supply chain, including quality verification certificate batches, was transparently shared, making our audit approvals seamless.",
      author: "Shri. Sanjay Deshmukh",
      role: "Chief Quality Control Officer, Department of Agriculture, Government of Maharashtra",
      rating: 5,
      avatar: "/img/avatar_mh_deshmukh.png"
    },
    {
      text: "For our state-wide fruit crop development programs, we needed a certified organic promoter available in bulk. Orbifert supplied Super Novel promptly. Its impact on flowering and heavy fruiting has made it highly popular among farmers. Excellent government procurement partner.",
      author: "Smt. Arundhati Bhattacharya",
      role: "Joint Secretary (Horticulture), Department of Agriculture & Farmers' Empowerment, Government of Odisha",
      rating: 5,
      avatar: "/img/avatar_odisha_bhattacharya.png"
    },
    {
      text: "We recommended BIO-ORBI Super Novel for state seed multiplication farms. The vegetative growth enhancement and root health improvements are verified by our field officers. Orbifert's compliance with state e-procurement guidelines and GeM listing made the bulk purchase efficient.",
      author: "Dr. Anil Mukhopadhyay",
      role: "Director (Organic Certifications), Department of Agriculture, Government of West Bengal",
      rating: 5,
      avatar: "/img/avatar_wb_mukhopadhyay.png"
    }
  ];

  const getTestItemsPerView = () => {
    if (window.innerWidth <= 768) return 1;
    return 3;
  };
  const [testItemsPerView, setTestItemsPerView] = useState(getTestItemsPerView());

  useEffect(() => {
    const handleResize = () => {
      setTestItemsPerView(getTestItemsPerView());
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const handleNextTestimonial = () => {
    if (noTransition) return;
    setCurrentTestimonialIndex(prev => prev + 1);
  };

  const handlePrevTestimonial = () => {
    if (noTransition) return;
    setCurrentTestimonialIndex(prev => prev - 1);
  };

  useEffect(() => {
    if (currentTestimonialIndex === testimonials.length) {
      const timer = setTimeout(() => {
        setNoTransition(true);
        setCurrentTestimonialIndex(0);
      }, 500);
      return () => clearTimeout(timer);
    }
    if (currentTestimonialIndex === -1) {
      const timer = setTimeout(() => {
        setNoTransition(true);
        setCurrentTestimonialIndex(testimonials.length - 1);
      }, 500);
      return () => clearTimeout(timer);
    }
  }, [currentTestimonialIndex, testimonials.length]);

  useEffect(() => {
    if (noTransition) {
      const timer = setTimeout(() => {
        setNoTransition(false);
      }, 50);
      return () => clearTimeout(timer);
    }
  }, [noTransition]);

  const renderedTestimonials = [
    testimonials[testimonials.length - 1],
    ...testimonials,
    ...testimonials.slice(0, 3)
  ];


  // GSAP Animations Hook
  useEffect(() => {
    // 1. Entrance animations
    const headerTargets = window.innerWidth > 768
      ? '.top-utility-bar, .main-header, .navigation-bar'
      : '.main-header';

    gsap.fromTo(headerTargets,
      { y: -100, opacity: 0 },
      { y: 0, opacity: 1, duration: 1, ease: 'power3.out', stagger: 0.1 }
    );

    gsap.fromTo('.hero-text-box',
      { y: 80, opacity: 0 },
      { y: 0, opacity: 1, duration: 1.2, delay: 0.3, ease: 'power3.out' }
    );

    // 2. Scroll-triggered animations
    gsap.fromTo('.feature-card',
      { y: 50, opacity: 0 },
      {
        y: 0, opacity: 1, duration: 0.8, stagger: 0.15, ease: 'power2.out',
        scrollTrigger: {
          trigger: '.features-row-section',
          start: 'top 85%',
        }
      }
    );

    gsap.fromTo('.top-products-section .section-header',
      { y: 40, opacity: 0 },
      {
        y: 0, opacity: 1, duration: 0.8, ease: 'power2.out',
        scrollTrigger: {
          trigger: '.top-products-section',
          start: 'top 80%',
        }
      }
    );

    gsap.fromTo('.accordion-card-row',
      { x: -50, opacity: 0 },
      {
        x: 0, opacity: 1, duration: 0.8, stagger: 0.15, ease: 'power2.out',
        scrollTrigger: {
          trigger: '.top-products-accordion-layout',
          start: 'top 80%',
        }
      }
    );

    gsap.fromTo('.discount-banner-card',
      { scale: 0.9, opacity: 0 },
      {
        scale: 1, opacity: 1, duration: 1, ease: 'power2.out',
        scrollTrigger: {
          trigger: '.mid-discount-banner-section',
          start: 'top 85%',
        }
      }
    );

    gsap.fromTo('.spotlight-card',
      { y: 60, opacity: 0 },
      {
        y: 0, opacity: 1, duration: 0.8, stagger: 0.2, ease: 'power2.out',
        scrollTrigger: {
          trigger: '.product-spotlight-section',
          start: 'top 80%',
        }
      }
    );

    gsap.fromTo('.pest-solution-card',
      { y: 40, opacity: 0 },
      {
        y: 0, opacity: 1, duration: 0.6, stagger: 0.08, ease: 'power2.out',
        scrollTrigger: {
          trigger: '.shop-by-pest-section',
          start: 'top 85%',
        }
      }
    );

    gsap.fromTo('.testimonial-card',
      { x: 50, opacity: 0 },
      {
        x: 0, opacity: 1, duration: 0.8, stagger: 0.2, ease: 'power2.out',
        scrollTrigger: {
          trigger: '.testimonials-section',
          start: 'top 85%',
        }
      }
    );

    gsap.fromTo('.blog-card',
      { y: 50, opacity: 0 },
      {
        y: 0, opacity: 1, duration: 0.8, stagger: 0.15, ease: 'power2.out',
        scrollTrigger: {
          trigger: '.knowledge-hub-section',
          start: 'top 85%',
        }
      }
    );

    return () => {
      ScrollTrigger.getAll().forEach(t => t.kill());
    };
  }, []);

  return (
    <div className="orbifert-landing-wrapper">

      {/* Toast Notification */}
      {notification && (
        <div className="toast-notification">
          <span>{notification}</span>
        </div>
      )}

      {/* Master Admin Purchase Block Alert Modal */}
      {isMasterAdminPromptOpen && (
        <div className="admin-block-modal-overlay flex-center" onClick={() => setIsMasterAdminPromptOpen(false)}>
          <div className="admin-block-modal-card animate-scale-up" onClick={(e) => e.stopPropagation()}>
            <div className="admin-block-modal-header">
              <div className="admin-block-icon-circle">
                <FiShield size={36} />
              </div>
              <h3>Master Admin Alert</h3>
            </div>
            <div className="admin-block-modal-body">
              <p className="admin-block-main-msg">Purchasing is unavailable for Master Admin accounts.</p>
              <p className="admin-block-sub-msg">
                This account is intended for managing products, orders, and website operations. Please use a customer account to purchase products.
              </p>
            </div>
            <div className="admin-block-modal-footer">
              <button
                className="btn btn-primary admin-block-close-btn"
                onClick={() => setIsMasterAdminPromptOpen(false)}
              >
                Understood
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Extracted Reusable Header Component */}
      {activePage !== 'admin' && activePage !== '404' && activePage !== 'my-orders' && activePage !== 'checkout' && activePage !== 'ios-app' && activePage !== 'apk-app' && (
        <Header
          activePage={activePage}
          cartItems={cartItems}
          wishlistItems={wishlistItems}
          onOpenCart={() => setIsCartOpen(true)}
          onOpenWishlist={() => setIsWishlistOpen(true)}
          onOpenAuth={(mode = 'login') => { setIsAuthOpen(true); setAuthMode(mode); }}
          triggerNotification={triggerNotification}
          selectedCurr={selectedCurr}
          setSelectedCurr={setSelectedCurr}
          onNavigate={handleNavigate}
          isProductDetailsOpen={!!selectedProduct}
          onProductClick={navigateToProduct}
          onBlogClick={navigateToBlog}
          currentUser={currentUser}
          onLogout={handleLogout}
          onOpenAdmin={() => { navigate('/admin'); }}
          onOpenOrderHistory={handleOpenOrderHistory}
          onOpenProfile={handleOpenProfile}
        />
      )}

      {activePage === '404' ? (
        <NotFound />
      ) : activePage === 'product' ? (
        <ProductDetails
          product={selectedProduct}
          onBack={() => { navigate(-1); }}
          onAddToCart={handleAddToCart}
          onAddToWishlist={handleAddToWishlist}
          onBuyNow={(checkoutId) => {
            if (currentUser && currentUser.roles && currentUser.roles.includes('Master Admin')) {
              setIsMasterAdminPromptOpen(true);
            } else {
              navigate(`/checkout/${checkoutId}`);
            }
          }}
          selectedCurr={selectedCurr}
          convertPrice={convertPrice}
        />
      ) : activePage === 'blog' ? (
        selectedBlog ? (
          <BlogDetails
            blog={selectedBlog}
            onBack={() => { navigate(-1); }}
            triggerNotification={triggerNotification}
          />
        ) : (
          <div style={{ padding: '100px 0', textCenter: 'center', minHeight: '60vh', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
            <div className="loading-spinner">Loading article...</div>
          </div>
        )
      ) : activePage === 'ios-app' ? (
        <AppComingSoon
          platform="ios"
          onBack={() => { navigate('/'); }}
        />
      ) : activePage === 'apk-app' ? (
        <AppComingSoon
          platform="android"
          onBack={() => { navigate('/'); }}
        />
      ) : activePage === 'help-center' ? (
        <HelpCenter
          onBack={() => { navigate('/'); }}
        />
      ) : activePage === 'about' ? (
        <AboutUs
          onBack={() => { navigate('/'); }}
          onNavigateProducts={() => handleNavigate('shop')}
        />
      ) : activePage === 'contact' ? (
        <ContactUs
          onBack={() => { navigate('/'); }}
          triggerNotification={triggerNotification}
        />
      ) : activePage === 'admin' ? (
        <AdminDashboard
          currentUser={currentUser}
          onLogout={handleLogout}
          onBack={() => { navigate('/'); }}
          triggerNotification={triggerNotification}
          onStorefrontLayoutSaved={handleStorefrontLayoutSaved}
        />
      ) : activePage === 'shop' ? (
        <ShopPage
          onProductClick={navigateToProduct}
          onAddToCart={handleAddToCart}
          onAddToWishlist={handleAddToWishlist}
          wishlistItems={wishlistItems}
          convertPrice={convertPrice}
          selectedCurr={selectedCurr}
          onBack={() => { navigate('/'); }}
        />
      ) : activePage === 'knowledge' ? (
        <KnowledgeHub
          onBlogClick={navigateToBlog}
          onBack={() => { navigate('/'); }}
        />
      ) : activePage === 'my-orders' ? (
        <MyOrdersPage
          currentUser={currentUser}
          triggerNotification={triggerNotification}
          convertPrice={convertPrice}
          selectedCurr={selectedCurr}
        />
      ) : activePage === 'profile' ? (
        <ProfilePage
          currentUser={currentUser}
          setCurrentUser={setCurrentUser}
          triggerNotification={triggerNotification}
          onBack={() => { navigate('/'); }}
        />
      ) : activePage === 'pest-diseases' ? (
        <PestDiseasesPage
          onBack={() => { navigate('/'); }}
          triggerNotification={triggerNotification}
        />
      ) : activePage === 'our-products' ? (
        <ProductRangePage />
      ) : activePage === 'checkout' ? (
        <CheckoutPage
          checkoutId={id}
          cartItems={cartItems}
          setCartItems={setCartItems}
          currentUser={currentUser}
          triggerNotification={triggerNotification}
          selectedCurr={selectedCurr}
          convertPrice={convertPrice}
          onBack={() => { navigate(-1); }}
        />
      ) : (
        <>
          {/* Hero Section Slider */}
          <section
            className="hero-section"
            id="home"
            onMouseEnter={() => setIsHeroHovered(true)}
            onMouseLeave={() => setIsHeroHovered(false)}
          >
            <div
              className="hero-slider-track"
              style={{
                width: `${heroBanners.length * 100}%`,
                transform: `translateX(-${currentHeroIndex * (100 / heroBanners.length)}%)`
              }}
            >
              {heroBanners.map((banner, index) => {
                const slideContent = (
                  <div
                    className={`hero-slide-item hero-slide-${banner.variant}`}
                    style={{
                      width: `${100 / heroBanners.length}%`,
                      flex: `0 0 ${100 / heroBanners.length}%`
                    }}
                  >
                    <div className="hero-slide-bg" style={{ backgroundImage: `url('${banner.img}')` }}></div>

                    {/* Floating badge & bottom bar for GeM government banner slide (variant 'gem-gov') */}
                    {banner.variant === 'gem-gov' && (
                      <>
                        {/* Floating Top-Right Badge */}


                        {/* Bottom Full-Width Bar */}

                      </>
                    )}

                    <div className="container hero-content-inner">
                      <div className="hero-text-box">

                        {/* ---- Banner: GEM Gov ---- */}
                        {banner.variant === 'gem-gov' && (
                          <>
                            {/* Top Left: GeM branding logo */}
                            <div className="hero-gem-logo-container">
                              <img src={banner.logo} alt="GeM Government e Marketplace" className="hero-gem-brand-logo" />
                            </div>

                            {/* Main Title */}
                            <h2 className="hero-gem-title">
                              <span className="title-dark-line">Reviving Soil.</span>
                              <span className="title-dark-line">Rewarding Farmers.</span>
                            </h2>

                            {/* Subtitle */}
                            <p className="hero-sub">
                              Premium Organic Fertilisers &amp; Biological Crop Inputs
                            </p>

                            <div className="hero-leaf-divider"><FaLeaf /></div>

                            {/* Badges row */}
                            <div className="hero-badges-row">
                              {banner.badges && banner.badges.map((b, i) => {
                                const gemIcons = [<GiSeedling />, <GiPlantRoots />, <FiShield />, <GiWaterDrop />];
                                return (
                                  <div key={i} className="hero-badge-item">
                                    <div className="hero-badge-icon">{gemIcons[i] || <GiSeedling />}</div>
                                    <span className="hero-badge-label">{b}</span>
                                  </div>
                                );
                              })}
                            </div>

                            {/* CTA Buttons Row */}
                            <div className="hero-gem-cta-row">
                              <a
                                href="https://gem.gov.in"
                                target="_blank"
                                rel="noopener noreferrer"
                                className="btn btn-primary hero-btn flex-center"
                                style={{ textDecoration: 'none', display: 'inline-flex' }}
                              >
                                <SVGIcon name="cart" size={16} stroke="#ffffff" /> BUY NOW ON GeM
                              </a>
                            </div>
                          </>
                        )}

                        {/* ---- Banner: Novel ---- */}
                        {banner.variant === 'novel' && (
                          <>
                            <div className="hero-gem-logo-container">
                              <img src="/hero-section-banner/GeM-logo.webp" alt="GeM Government e Marketplace" className="hero-gem-brand-logo" />
                            </div>
                            <h2 className="hero-h2-novel">
                              <span className="title-dark-line">{banner.titleDark}</span>
                              <span className="title-accent-line">{banner.titleAccent}</span>
                            </h2>
                            <p className="hero-sub">{banner.subtitle}</p>
                            <div className="hero-leaf-divider"><FaLeaf /></div>
                            <div className="hero-badges-row">
                              {banner.badges.map((b, i) => {
                                const novelIcons = [<GiPlantSeed />, <GiPlantRoots />, <GiFertilizerBag />, <GiEcology />];
                                return (
                                  <div key={i} className="hero-badge-item">
                                    <div className="hero-badge-icon">{novelIcons[i] || <GiPlantSeed />}</div>
                                    <span className="hero-badge-label">{b}</span>
                                  </div>
                                );
                              })}
                            </div>
                            <a
                              href="https://gem.gov.in"
                              target="_blank"
                              rel="noopener noreferrer"
                              className="btn btn-primary hero-btn flex-center"
                              style={{ textDecoration: 'none', display: 'inline-flex' }}
                            >
                              <SVGIcon name="cart" size={16} stroke="#ffffff" /> Buy Now on GeM
                            </a>
                          </>
                        )}

                        {/* ---- Banner: Prime ---- */}
                        {banner.variant === 'prime' && (
                          <>
                            <div className="hero-gem-logo-container">
                              <img src="/hero-section-banner/GeM-logo.webp" alt="GeM Government e Marketplace" className="hero-gem-brand-logo" />
                            </div>
                            <h2 className="hero-h2-prime">
                              <span className="title-script-line">{banner.scriptLine}</span>
                              <span className="title-bold-line">{banner.boldLine}</span>
                            </h2>
                            <div className="hero-descriptor-box">{banner.descriptor}</div>
                            <div className="hero-leaf-divider"><FaLeaf /></div>
                            <div className="hero-badges-row" style={{ justifyContent: 'flex-start' }}>
                              {banner.badges.map((b, i) => {
                                const primeIcons = [<GiSeedling />, <GiGreenhouse />, <GiWaterDrop />, <GiPlantWatering />];
                                return (
                                  <div key={i} className="hero-badge-item">
                                    <div className="hero-badge-icon">{primeIcons[i] || <GiSeedling />}</div>
                                    <span className="hero-badge-label">{b}</span>
                                  </div>
                                );
                              })}
                            </div>
                            <button
                              className="btn hero-btn flex-center"
                              disabled
                              style={{ background: '#1c6901', color: '#ffffff', cursor: 'not-allowed', display: 'inline-flex', fontWeight: 700, letterSpacing: '0.5px' }}
                            >
                              <SVGIcon name="cart" size={16} stroke="#ffffff" /> Launching Soon
                            </button>
                          </>
                        )}

                        {/* ---- Banner: Nutrition ---- */}
                        {banner.variant === 'nutrition' && (
                          <>
                            <div className="hero-gem-logo-container">
                              <img src="/hero-section-banner/GeM-logo.webp" alt="GeM Government e Marketplace" className="hero-gem-brand-logo" />
                            </div>
                            <h2 className="hero-h2-nutrition">
                              <span className="title-dark-line">{banner.titleLine1}</span>
                              <span className="title-accent-line">{banner.titleLine2}</span>
                            </h2>
                            <p className="hero-sub">{banner.subtitle}</p>
                            <div className="hero-leaf-divider"><FaLeaf /></div>
                            <div className="hero-badges-row">
                              {banner.badges.map((b, i) => {
                                const nutriIcons = [<GiEcology />, <GiPlantSeed />, <GiPlantRoots />, <GiGreenhouse />];
                                return (
                                  <div key={i} className="hero-badge-item">
                                    <div className="hero-badge-icon">{nutriIcons[i] || <GiEcology />}</div>
                                    <span className="hero-badge-label">{b}</span>
                                  </div>
                                );
                              })}
                            </div>
                            <button
                              className="btn hero-btn flex-center"
                              disabled
                              style={{ background: '#1c6901', color: '#ffffff', cursor: 'not-allowed', display: 'inline-flex', fontWeight: 700, letterSpacing: '0.5px' }}
                            >
                              <SVGIcon name="cart" size={16} stroke="#ffffff" /> Launching Soon
                            </button>
                          </>
                        )}

                        {/* ---- Banner: Brand Trust ---- */}
                        {banner.variant === 'trust' && (
                          <>
                            <div className="hero-gem-logo-container">
                              <img src="/hero-section-banner/GeM-logo.webp" alt="GeM Government e Marketplace" className="hero-gem-brand-logo" />
                            </div>
                            <h2 className="hero-h2-novel">
                              <span className="title-dark-line">{banner.titleDark}</span>
                              <span className="title-accent-line">{banner.titleAccent}</span>
                            </h2>
                            <p className="hero-sub">{banner.subtitle}</p>
                            <div className="hero-leaf-divider"><FaLeaf /></div>
                            <div className="hero-badges-row">
                              {banner.badges.map((b, i) => {
                                const trustIcons = [<FiAward />, <GiSeedling />, <FiShield />];
                                return (
                                  <div key={i} className="hero-badge-item">
                                    <div className="hero-badge-icon">{trustIcons[i] || <FiAward />}</div>
                                    <span className="hero-badge-label">{b}</span>
                                  </div>
                                );
                              })}
                            </div>
                            <a
                              href="https://gem.gov.in"
                              target="_blank"
                              rel="noopener noreferrer"
                              className="btn btn-primary hero-btn flex-center"
                              style={{ textDecoration: 'none', display: 'inline-flex' }}
                            >
                              <SVGIcon name="cart" size={16} stroke="#ffffff" /> Buy Now on GeM
                            </a>
                          </>
                        )}

                      </div>
                    </div>
                  </div>
                );

                // If the banner has a link (excluding gem-gov), wrap the entire slide in an anchor tag
                if (banner.link && banner.variant !== 'gem-gov') {
                  return (
                    <a
                      key={index}
                      href={banner.link}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="hero-slide-link-wrapper"
                      aria-label="Visit GeM Government Portal"
                    >
                      {slideContent}
                    </a>
                  );
                }

                return React.cloneElement(slideContent, { key: index });
              })}
            </div>

            {/* Carousel indicators */}
            <div className="slider-indicators">
              {heroBanners.map((_, index) => (
                <button
                  key={index}
                  className={`indicator-dot ${currentHeroIndex === index ? 'active' : ''}`}
                  onClick={() => setCurrentHeroIndex(index)}
                ></button>
              ))}
            </div>
          </section>

          {/* Trust Badges Features Row */}
          <section className="features-row-section">
            <div className="container features-grid">
              <div className="feature-card">
                <div className="feature-icon-circle">
                  <SVGIcon name="shipping" size={26} stroke="var(--primary)" />
                </div>
                <div className="feature-text">
                  <h3>{t('freeShipping')}</h3>
                  <p>{t('freeShippingDesc')}</p>
                </div>
              </div>
              <div className="feature-card">
                <div className="feature-icon-circle">
                  <SVGIcon name="support" size={26} stroke="var(--primary)" />
                </div>
                <div className="feature-text">
                  <h3>{t('greatSupport')}</h3>
                  <p>{t('greatSupportDesc')}</p>
                </div>
              </div>
              <div className="feature-card">
                <div className="feature-icon-circle">
                  <SVGIcon name="secure" size={26} stroke="var(--primary)" />
                </div>
                <div className="feature-text">
                  <h3>{t('securePayment')}</h3>
                  <p>{t('securePaymentDesc')}</p>
                </div>
              </div>
              <div className="feature-card">
                <div className="feature-icon-circle">
                  <SVGIcon name="guarantee" size={26} stroke="var(--primary)" />
                </div>
                <div className="feature-text">
                  <h3>{t('moneyBack')}</h3>
                  <p>{t('moneyBackDesc')}</p>
                </div>
              </div>
            </div>
          </section>

          {/* Top Products / Best Sale (Restructured vertical card accordion) */}
          <section className="top-products-section" id="products">
            <div className="container">
              <div className="section-header text-center">
                <span className="section-subtitle-tag">{t('topProducts')}</span>
                <h2>{t('bestSale')}</h2>
              </div>

              <div className="top-products-accordion-layout">
                {/* Sidebar Leaf Image Column */}
                <div className="accordion-leaf-sidebar">
                  <img src="/banner/Mask group.png" alt="Leaf Sidebar Background" className="leaf-sidebar-img" />
                </div>

                {/* Accordion Cards column */}
                <div className="accordion-cards-container">
                  {resolvedTopProducts.map((rawProd, slotIdx) => {
                    // Use DB product data directly — title, desc, image all come from the database
                    const prod = { ...rawProd };
                    const activeTopProductToUse = activeTopProduct !== null ? activeTopProduct : (resolvedTopProducts[0]?.id || 1);
                    const isActive = prod.id === activeTopProductToUse;
                    const qty = productQuantities[prod.id] || 1;

                    return (
                      <div
                        key={prod.id}
                        className={`accordion-card-row ${isActive ? 'active-row' : 'collapsed-row'}`}
                        onClick={() => setActiveTopProduct(prod.id)}
                      /* onMouseEnter removed to disable hover-triggered card expansion as requested */
                      >
                        {/* Slot Number (sequential 1-4, not DB id) */}
                        <div className="card-row-number">
                          {slotIdx + 1}
                        </div>

                        <div className="accordion-card-panel">
                          {/* Expanded Detail Active View */}
                          <div className="active-product-panel">
                            <div className="product-details-content">
                              <div className="product-details-main-info">
                                <div className="details-header">
                                  <span
                                    className="product-title-big"
                                    onClick={() => navigateToProduct({ id: prod.id, title: prod.title, price: prod.priceRaw || 170.28, image: prod.image })}
                                    style={{ cursor: 'pointer' }}
                                  >
                                    {prod.title}
                                  </span>
                                  <span className="stock-badge">{t('inStock')}</span>

                                  {/* Inline trust logos in active header */}
                                  <div className="active-header-logos-row">
                                    {slotIdx === 0 && (
                                      <img src="/logo/Orbifert Flagship Product logo.png" alt="Orbifert Flagship Product" className="active-header-logo" title="Orbifert Flagship Product" />
                                    )}
                                    <img src="/logo/NPOP Certified.png" alt="NPOP Certified" className="active-header-logo" title="NPOP Certified" />
                                    <img src="/logo/ISO 9001-2015.png" alt="ISO 9001-2015" className="active-header-logo" title="ISO 9001:2015" />
                                    <img src="/logo/ICAR Approved.png" alt="ICAR Approved" className="active-header-logo" title="ICAR Approved" />
                                    <img src="/logo/Eco-Packaging.png" alt="Eco Friendly" className="active-header-logo" title="Eco-Packaging" />
                                    <img src="/logo/logo_632abd28aea16.png" alt="Navsari Agricultural University" className="active-header-logo" title="Navsari Agricultural University" />
                                  </div>
                                </div>

                                {/* Stars and SKU */}
                                <div className="rating-sku-row">
                                  <div className="stars-group" style={{ display: 'flex', gap: '4px', alignItems: 'center' }}>
                                    {Array.from({ length: 5 }).map((_, i) => {
                                      if (i < Math.floor(prod.rating)) {
                                        return <FaStar key={i} style={{ color: '#FF8A00', fontSize: '16px' }} />;
                                      } else if (i === Math.floor(prod.rating) && prod.rating % 1 !== 0) {
                                        return <FaStarHalfAlt key={i} style={{ color: '#FF8A00', fontSize: '16px' }} />;
                                      } else {
                                        return <FaStar key={i} style={{ color: '#CCCCCC', fontSize: '16px' }} />;
                                      }
                                    })}
                                    <span className="reviews-text">{prod.reviewsCount} {t('reviews')}</span>
                                  </div>
                                  <span className="sku-label">{t('sku')}: <span className="sku-val">{prod.sku}</span></span>
                                </div>

                                {/* Price Row - only for Super Novel */}
                                {prod.title.toLowerCase().includes('super novel') && (
                                  <div className="price-discount-row">
                                    <span className="new-price-bold">{convertPrice(prod.newPrice, selectedCurr)}</span>
                                  </div>
                                )}

                                {/* Brand Info & Share */}
                                <div className="brand-share-row">
                                  <div className="brand-wrap">
                                    <span className="brand-label">{t('brand')}:</span>
                                    <span className="brand-name">🌱 Orbifert</span>
                                  </div>
                                  <div className="share-wrap">
                                    <span className="share-label">{t('shareItem')}:</span>
                                    <div className="share-social-icons" style={{ display: 'flex', gap: '6px', alignItems: 'center' }} onClick={(e) => e.stopPropagation()}>
                                      <a
                                        href={`https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(window.location.href)}`}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        onClick={() => {
                                          navigator.clipboard.writeText(window.location.href);
                                          triggerNotification("Product link copied! Opening Facebook...");
                                        }}
                                        title="Share on Facebook"
                                      >
                                        <SVGIcon name="facebook" size={16} className="social-icon" />
                                      </a>
                                      <a
                                        href={`https://twitter.com/intent/tweet?url=${encodeURIComponent(window.location.href)}`}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        onClick={() => {
                                          navigator.clipboard.writeText(window.location.href);
                                          triggerNotification("Product link copied! Opening Twitter...");
                                        }}
                                        title="Share on Twitter"
                                      >
                                        <SVGIcon name="twitter" size={16} className="social-icon" />
                                      </a>
                                      <a
                                        href="https://instagram.com"
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        onClick={() => {
                                          navigator.clipboard.writeText(window.location.href);
                                          triggerNotification("Product link copied! Opening Instagram...");
                                        }}
                                        title="Share on Instagram"
                                      >
                                        <SVGIcon name="instagram" size={16} className="social-icon" />
                                      </a>
                                    </div>
                                  </div>
                                </div>

                                {/* Description */}
                                <p className="product-description-para">{prod.desc}</p>

                                {/* Interaction Row - Decoupled Frontend Catalog */}
                                <div className="product-interaction-row" onClick={(e) => e.stopPropagation()}>
                                  {prod.title.toLowerCase().includes('super novel') ? (
                                    <a
                                      href="https://gem.gov.in"
                                      target="_blank"
                                      rel="noopener noreferrer"
                                      className="btn btn-primary add-cart-btn flex-center"
                                      style={{ textDecoration: 'none', width: '100%', maxWidth: '280px' }}
                                    >
                                      Buy on GeM ➔
                                    </a>
                                  ) : (
                                    <button
                                      className="btn btn-primary add-cart-btn flex-center"
                                      disabled
                                      style={{ background: '#f4f7f3', border: '1.5px dashed #b2cbb0', color: '#7a8c78', cursor: 'not-allowed', width: '100%', maxWidth: '280px' }}
                                    >
                                      Launching Soon
                                    </button>
                                  )}
                                </div>

                                {/* Meta links */}
                                <div className="product-meta-footer">
                                  <div><span className="meta-label">{t('category')}:</span> <span className="meta-val">{prod.category}</span></div>
                                  <div>
                                    <span className="meta-label">{t('tags')}:</span>
                                    {prod.tags.map((tg, idx) => (
                                      <span key={idx} className="meta-tag-pill">{tg}</span>
                                    ))}
                                  </div>
                                </div>
                              </div>
                            </div>

                            <div className="product-image-preview">
                              <div className="blob-bg-shape"></div>
                              {slotIdx === 0 && (
                                <img
                                  src="/logo/Orbifert Flagship Product logo.png"
                                  alt="Orbifert Flagship Product"
                                  className="flagship-floating-badge"
                                />
                              )}
                              <img
                                src={prod.image}
                                alt={prod.title}
                                className="product-large-img"
                                onClick={() => navigateToProduct({ id: prod.id, title: prod.title, price: prod.priceRaw || 170.28, image: prod.image })}
                                style={{ cursor: 'pointer' }}
                              />
                            </div>
                          </div>

                          {/* Collapsed Compact View */}
                          <div className="collapsed-product-panel">
                            <div className="collapsed-details-content">
                              <div className="collapsed-header-row">
                                <span
                                  className="collapsed-title"
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    navigateToProduct({ id: prod.id, title: prod.title, price: prod.priceRaw || 170.28, image: prod.image });
                                  }}
                                  style={{ cursor: 'pointer' }}
                                >
                                  {prod.title}
                                </span>
                                <span className="stock-badge">{t('inStock')}</span>

                                {/* Inline trust logos in collapsed header */}
                                <div className="collapsed-header-logos-row">
                                  {slotIdx === 0 && (
                                    <img src="/logo/Orbifert Flagship Product logo.png" alt="Orbifert Flagship Product" className="collapsed-header-logo" title="Orbifert Flagship Product" />
                                  )}
                                  <img src="/logo/NPOP Certified.png" alt="NPOP Certified" className="collapsed-header-logo" title="NPOP Certified" />
                                  <img src="/logo/ISO 9001-2015.png" alt="ISO 9001-2015" className="collapsed-header-logo" title="ISO 9001:2015" />
                                  <img src="/logo/ICAR Approved.png" alt="ICAR Approved" className="collapsed-header-logo" title="ICAR Approved" />
                                  <img src="/logo/Eco-Packaging.png" alt="Eco Friendly" className="collapsed-header-logo" title="Eco-Packaging" />
                                  <img src="/logo/logo_632abd28aea16.png" alt="Navsari Agricultural University" className="collapsed-header-logo" title="Navsari Agricultural University" />
                                </div>
                              </div>

                              <div className="collapsed-rating-price-row">
                                <div className="stars-group" style={{ display: 'flex', gap: '4px', alignItems: 'center' }}>
                                  {Array.from({ length: 5 }).map((_, i) => {
                                    if (i < Math.floor(prod.rating)) {
                                      return <FaStar key={i} style={{ color: '#FF8A00', fontSize: '14px' }} />;
                                    } else if (i === Math.floor(prod.rating) && prod.rating % 1 !== 0) {
                                      return <FaStarHalfAlt key={i} style={{ color: '#FF8A00', fontSize: '14px' }} />;
                                    } else {
                                      return <FaStar key={i} style={{ color: '#CCCCCC', fontSize: '14px' }} />;
                                    }
                                  })}
                                  <span className="reviews-text">{prod.reviewsCount} {t('reviews')}</span>
                                </div>
                                <span className="collapsed-sku">{t('sku')}: {prod.sku}</span>
                              </div>

                              {prod.title.toLowerCase().includes('super novel') && (
                                <div className="collapsed-price-row">
                                  <span className="new-price-bold">{convertPrice(prod.newPrice, selectedCurr)}</span>
                                </div>
                              )}

                              <div className="collapsed-brand-share">
                                <div className="brand-wrap">
                                  <span className="brand-label">{t('brand')}:</span>
                                  <span className="brand-name">🌱 Orbifert</span>
                                </div>
                                <div className="share-wrap">
                                  <span className="share-label">{t('shareItem')}:</span>
                                  <div className="share-social-icons" style={{ display: 'flex', gap: '6px', alignItems: 'center' }} onClick={(e) => e.stopPropagation()}>
                                    <a
                                      href={`https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(window.location.href)}`}
                                      target="_blank"
                                      rel="noopener noreferrer"
                                      onClick={() => {
                                        navigator.clipboard.writeText(window.location.href);
                                        triggerNotification("Product link copied! Opening Facebook...");
                                      }}
                                      title="Share on Facebook"
                                    >
                                      <SVGIcon name="facebook" size={12} className="social-icon" />
                                    </a>
                                    <a
                                      href={`https://twitter.com/intent/tweet?url=${encodeURIComponent(window.location.href)}`}
                                      target="_blank"
                                      rel="noopener noreferrer"
                                      onClick={() => {
                                        navigator.clipboard.writeText(window.location.href);
                                        triggerNotification("Product link copied! Opening Twitter...");
                                      }}
                                      title="Share on Twitter"
                                    >
                                      <SVGIcon name="twitter" size={12} className="social-icon" />
                                    </a>
                                    <a
                                      href="https://instagram.com"
                                      target="_blank"
                                      rel="noopener noreferrer"
                                      onClick={() => {
                                        navigator.clipboard.writeText(window.location.href);
                                        triggerNotification("Product link copied! Opening Instagram...");
                                      }}
                                      title="Share on Instagram"
                                    >
                                      <SVGIcon name="instagram" size={12} className="social-icon" />
                                    </a>
                                  </div>
                                </div>
                              </div>

                              <p className="collapsed-desc-para">{(prod.desc || '').substring(0, 160)}...</p>
                            </div>

                            <div className="collapsed-right-content" onClick={(e) => e.stopPropagation()}>
                              {prod.title.toLowerCase().includes('super novel') ? (
                                <a
                                  href="https://gem.gov.in"
                                  target="_blank"
                                  rel="noopener noreferrer"
                                  className="collapsed-add-cart-btn flex-center"
                                  style={{ textDecoration: 'none' }}
                                >
                                  Buy on GeM
                                </a>
                              ) : (
                                <button
                                  className="collapsed-add-cart-btn flex-center"
                                  disabled
                                  style={{ background: '#f4f7f3', border: '1px dashed #b2cbb0', color: '#7a8c78', cursor: 'not-allowed' }}
                                >
                                  Launching Soon
                                </button>
                              )}
                              <div className="collapsed-img-preview">
                                <img
                                  src={prod.image}
                                  alt={prod.title}
                                  className="collapsed-small-img"
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    navigateToProduct({ id: prod.id, title: prod.title, price: prod.priceRaw || 170.28, image: prod.image });
                                  }}
                                  style={{ cursor: 'pointer' }}
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    );
                  })}
                </div>
              </div>
            </div>
          </section>

          {/* Mid Promo Summer Sale Banner */}
          <section className="mid-discount-banner-section">
            <div className="container">
              <div className="discount-banner-card" style={{ backgroundImage: `url('/banner/Discount Bannar.png')` }}>
                <div className="banner-content-overlay">
                  <span className="summer-sale-label">SUMMER SALE</span>
                  <h2 className="discount-title"><span>37%</span> OFF</h2>
                  <p className="discount-subtext">Free on all your order, Free Shipping and 30 money-back guarantee</p>
                  <button
                    className="btn btn-primary discount-shop-btn flex-center"
                    onClick={() => triggerNotification("Opening Summer Sale collection...")}
                  >
                    Shop Now <SVGIcon name="arrowRight" size={16} stroke="#ffffff" />
                  </button>
                </div>
              </div>
            </div>
          </section>

          {/* Product Spotlight - Premium Range */}
          <section className="product-spotlight-section">
            <div className="container">
              <div className="spotlight-header text-center">
                <h2 className="spotlight-title">FASAL KE HERO</h2>
                <p className="spotlight-subtitle">Nurturing Every Harvest</p>
              </div>

              <div className="spotlight-grid">
                {resolvedSpotlightProducts.map((prod, index) => {
                  const isHighlight = index === 1;
                  return (
                    <div key={prod.id || index} className={`spotlight-card ${isHighlight ? 'highlight' : ''}`}>
                      <div className="spotlight-img-wrap">
                        <img
                          src={prod.image}
                          alt={prod.title}
                          className="spotlight-img"
                          onClick={() => navigateToProduct({ id: prod.id, title: prod.title, price: prod.price, image: prod.image })}
                          style={{ cursor: 'pointer' }}
                        />
                      </div>
                      <div className="spotlight-info">
                        <h3
                          onClick={() => navigateToProduct({ id: prod.id, title: prod.title, price: prod.price, image: prod.image })}
                          style={{ cursor: 'pointer' }}
                        >
                          {prod.title}
                        </h3>
                        {prod.title.toLowerCase().includes('super novel') && (
                          <div className="spotlight-price">{convertPrice(prod.price, selectedCurr)}</div>
                        )}
                        <div className="stars-group justify-center" style={{ display: 'flex', gap: '4px', justifyContent: 'center', alignItems: 'center' }}>
                          {Array.from({ length: 5 }).map((_, i) => {
                            if (i < Math.floor(prod.rating)) {
                              return <FaStar key={i} style={{ color: '#FF8A00', fontSize: '14px' }} />;
                            } else if (i === Math.floor(prod.rating) && prod.rating % 1 !== 0) {
                              return <FaStarHalfAlt key={i} style={{ color: '#FF8A00', fontSize: '14px' }} />;
                            } else {
                              return <FaStar key={i} style={{ color: '#CCCCCC', fontSize: '14px' }} />;
                            }
                          })}
                        </div>
                        {prod.title.toLowerCase().includes('super novel') ? (
                          <a
                            href="https://gem.gov.in"
                            target="_blank"
                            rel="noopener noreferrer"
                            className={isHighlight ? "card-cart-btn-green flex-center" : "card-cart-btn flex-center"}
                            style={{ textDecoration: 'none', display: 'flex', justifyContent: 'center', alignItems: 'center' }}
                          >
                            Buy on GeM ➔
                          </a>
                        ) : (
                          <button
                            className={isHighlight ? "card-cart-btn-green flex-center" : "card-cart-btn flex-center"}
                            disabled
                            style={{ background: '#f4f7f3', border: '1px dashed #b2cbb0', color: '#7a8c78', cursor: 'not-allowed', display: 'flex', justifyContent: 'center', alignItems: 'center' }}
                          >
                            Launching Soon
                          </button>
                        )}
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
          </section>

          {/* Shop By Pest & Disease */}
          <section className="shop-by-pest-section">
            <div className="container">
              <div className="flex-header-row">
                <div className="header-left">
                  <span className="section-subtitle-tag">SHOP BY PEST & DISEASE</span>
                  <h2>From struggling fields to thriving harvests — find your solution</h2>
                </div>
                <div className="header-right flex-center">
                  <button
                    className="btn-text-link flex-center"
                    onClick={() => {
                      navigate('/pest-diseases');
                      window.scrollTo(0, 0);
                    }}
                  >
                    View All <SVGIcon name="arrowRight" size={14} />
                  </button>
                </div>
              </div>

              <div className="pest-slider-container">
                <div
                  className="pest-solutions-track"
                  style={{
                    transform: `translateX(-${pestOffset * (100 / pestItemsPerView)}%)`
                  }}
                >
                  {pestSolutions.map((item, idx) => (
                    <div
                      key={idx}
                      className="pest-solution-card"
                      style={{
                        flex: `0 0 calc(${100 / pestItemsPerView}% - ${(20 * (pestItemsPerView - 1)) / pestItemsPerView}px)`,
                        width: `calc(${100 / pestItemsPerView}% - ${(20 * (pestItemsPerView - 1)) / pestItemsPerView}px)`
                      }}
                      onClick={() => {
                        navigate('/pest-diseases');
                        window.scrollTo(0, 0);
                      }}
                    >
                      <div className="solution-img-box">
                        <img src={item.img} alt={item.title} className="solution-thumb" />
                      </div>
                      <div className="pest-card-content">
                        <h3>{item.title}</h3>
                        <p>{item.sub}</p>
                      </div>
                    </div>
                  ))}
                </div>
              </div>

              <div className="pest-slider-navigation">
                <div className="slider-arrows">
                  <button
                    className="arrow-btn"
                    onClick={handlePrevPest}
                    disabled={pestOffset === 0}
                    style={{ opacity: pestOffset === 0 ? 0.4 : 1, cursor: pestOffset === 0 ? 'default' : 'pointer' }}
                  >
                    <SVGIcon name="arrowLeft" size={16} />
                  </button>
                  <button
                    className="arrow-btn green"
                    onClick={handleNextPest}
                    disabled={pestOffset >= pestSolutions.length - pestItemsPerView}
                    style={{ opacity: pestOffset >= pestSolutions.length - pestItemsPerView ? 0.4 : 1, cursor: pestOffset >= pestSolutions.length - pestItemsPerView ? 'default' : 'pointer' }}
                  >
                    <SVGIcon name="arrowRight" size={16} stroke="#ffffff" />
                  </button>
                </div>
              </div>
            </div>
          </section>

          {/* Farming with Orbifert - Bio Pest Control Promos */}
          <section className="farming-promo-section">
            <div className="container">
              <div className="section-header text-center">
                <span className="section-subtitle-tag">FARMING WITH ORBIFERT</span>
                <h2>Organic Bio-Fertilizers</h2>
              </div>

              <div className="farming-promos-grid">
                {/* Promo Card 1 */}
                <div className="farming-promo-card">
                  <video
                    autoPlay
                    loop
                    muted
                    playsInline
                    defaultMuted
                    controlsList="nodownload"
                    disablePictureInPicture
                    disableRemotePlayback
                    onContextMenu={(e) => e.preventDefault()}
                  >
                    <source src="/video/video1.mp4" type="video/mp4" />
                  </video>
                  <div className="promo-overlay-bg"></div>
                  <div className="promo-content">
                    <span className="promo-hot-tag">HOT SALE</span>
                    <h3>Save 37% on Pure Liquid Bio-Fertilizer Packs</h3>
                    <button
                      className="btn btn-light-promo flex-center"
                      onClick={() => {
                        navigate('/shop');
                        window.scrollTo(0, 0);
                      }}
                    >
                      Shop Now <SVGIcon name="arrowRight" size={14} />
                    </button>
                  </div>
                </div>

                {/* Promo Card 2 */}
                <div className="farming-promo-card">
                  <video
                    autoPlay
                    loop
                    muted
                    playsInline
                    defaultMuted
                    controlsList="nodownload"
                    disablePictureInPicture
                    disableRemotePlayback
                    onContextMenu={(e) => e.preventDefault()}
                  >
                    <source src="/video/video2.mp4" type="video/mp4" />
                  </video>
                  <div className="promo-overlay-bg"></div>
                  <div className="promo-content">
                    <span className="promo-hot-tag font-alt">NEW RELEASE</span>
                    <h3>100% Organic NPK & Soil Enhancer Formula</h3>
                    <button
                      className="btn btn-light-promo flex-center"
                      onClick={() => {
                        navigate('/shop');
                        window.scrollTo(0, 0);
                      }}
                    >
                      Shop Now <SVGIcon name="arrowRight" size={14} />
                    </button>
                  </div>
                </div>

                {/* Promo Card 3 */}
                <div className="farming-promo-card">
                  <video
                    autoPlay
                    loop
                    muted
                    playsInline
                    defaultMuted
                    controlsList="nodownload"
                    disablePictureInPicture
                    disableRemotePlayback
                    onContextMenu={(e) => e.preventDefault()}
                  >
                    <source src="/video/video3.mp4" type="video/mp4" />
                  </video>
                  <div className="promo-overlay-bg"></div>
                  <div className="promo-content">
                    <span className="promo-hot-tag">BEST PRICE</span>
                    <h3>Premium Compost & Natural Vermicompost Combo</h3>
                    <button
                      className="btn btn-light-promo flex-center"
                      onClick={() => {
                        navigate('/shop');
                        window.scrollTo(0, 0);
                      }}
                    >
                      Shop Now <SVGIcon name="arrowRight" size={14} />
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </section>

          {/* New Call to Action Mid-Section Banner */}
          <section className="mid-cta-banner-section">
            <div className="container">
              <div
                className="mid-cta-banner-card animate-scale-up"
                style={{
                  '--banner-bg-img': `url(${bannerBgError ? "https://images.unsplash.com/photo-1625246333195-78d9c38ad449?w=1600&auto=format&fit=crop&q=80" : "/banner/orbifert_landing_mid_banner_bg.png"})`
                }}
              >
                <div className="banner-text-side">
                  <span className="banner-tag-badge">Premium Soil Health</span>
                  <h2 className="banner-main-title">
                    Bumper Yields Start <br />
                    With Rich Organic Nutrition
                  </h2>
                  <p className="banner-desc-para">
                    Empower your farm with Orbifert's 100% organic plant growth supplements. Specially formulated to condition soil, supercharge root systems, and maximize crop potential naturally.
                  </p>
                  <button
                    className="btn cta-banner-shop-btn flex-center"
                    onClick={() => handleNavigate('shop')}
                  >
                    <span>Shop All Products</span>
                    <span className="btn-glow-layer"></span>
                    <SVGIcon name="arrowRight" size={16} stroke="#ffffff" />
                  </button>
                </div>
              </div>
            </div>
          </section>

          {/* Featured Products (Slider with arrow navigation) */}
          <section className="featured-products-section">
            <div className="container">
              <div className="flex-header-row">
                <div className="header-left">
                  <span className="section-subtitle-tag">Swadeshi PRODUCTS</span>
                  <h2>Our Featured Products</h2>
                </div>
                <div className="featured-header-actions">
                  <button
                    className="btn-text-link flex-center featured-view-all"
                    onClick={() => {
                      navigate('/shop');
                      window.scrollTo(0, 0);
                    }}
                  >
                    View All <SVGIcon name="arrowRight" size={14} />
                  </button>
                  <div className="slider-arrows featured-arrows">
                    <button
                      className="arrow-btn"
                      onClick={handlePrevFeatured}
                      disabled={featuredOffset === 0}
                      style={{ opacity: featuredOffset === 0 ? 0.4 : 1, cursor: featuredOffset === 0 ? 'default' : 'pointer' }}
                    >
                      <SVGIcon name="arrowLeft" size={20} />
                    </button>
                    <button
                      className="arrow-btn green"
                      onClick={handleNextFeatured}
                      disabled={featuredOffset >= resolvedFeaturedProducts.length - itemsPerView}
                      style={{ opacity: featuredOffset >= resolvedFeaturedProducts.length - itemsPerView ? 0.4 : 1, cursor: resolvedFeaturedProducts.length - itemsPerView ? 'default' : 'pointer' }}
                    >
                      <SVGIcon name="arrowRight" size={20} stroke="#ffffff" />
                    </button>
                  </div>
                </div>
              </div>

              <div className="featured-slider-container">
                <div
                  className="featured-products-track"
                  style={{ transform: `translateX(-${featuredOffset * (100 / itemsPerView)}%)` }}
                >
                  {resolvedFeaturedProducts.map((prod) => (
                    <div
                      key={prod.id}
                      className="featured-product-card"
                      style={{
                        flex: `0 0 calc(${100 / itemsPerView}% - ${(24 * (itemsPerView - 1)) / itemsPerView}px)`,
                        width: `calc(${100 / itemsPerView}% - ${(24 * (itemsPerView - 1)) / itemsPerView}px)`
                      }}
                    >
                      <div className="product-card-head">
                        {/* discount badge removed */}
                        {/* Heart wishlist removed */}
                        <div className="quick-view-overlay" onClick={() => navigateToProduct({ id: prod.id, title: prod.name, price: prod.price, image: prod.image })} style={{ cursor: 'pointer' }}>
                          <SVGIcon name="eye" size={18} stroke="#ffffff" />
                        </div>
                        <img
                          src={prod.image}
                          alt={prod.name}
                          className="product-card-img"
                          onClick={() => navigateToProduct({ id: prod.id, title: prod.name, price: prod.price, image: prod.image })}
                          style={{ cursor: 'pointer' }}
                        />
                      </div>
                      <div className="product-card-body">
                        <div className="featured-card-category">{prod.category || 'BIO FERTILIZERS'}</div>
                        <h3
                          onClick={() => navigateToProduct({ id: prod.id, title: prod.name, price: prod.price, image: prod.image })}
                          style={{ cursor: 'pointer' }}
                        >
                          {prod.name}
                        </h3>
                        <div className="featured-card-rating-row">
                          <div className="stars-group" style={{ display: 'inline-flex', gap: '2px', alignItems: 'center' }}>
                            {Array.from({ length: 5 }).map((_, i) => {
                              if (i < Math.floor(prod.rating)) {
                                return <FaStar key={i} style={{ color: '#FF8A00', fontSize: '12px' }} />;
                              } else if (i === Math.floor(prod.rating) && prod.rating % 1 !== 0) {
                                return <FaStarHalfAlt key={i} style={{ color: '#FF8A00', fontSize: '12px' }} />;
                              } else {
                                return <FaStar key={i} style={{ color: '#CCCCCC', fontSize: '12px' }} />;
                              }
                            })}
                          </div>
                          <span className="featured-card-rating-value">{prod.rating.toFixed(1)}</span>
                        </div>
                        {prod.isSuperNovel && (
                          <div className="featured-card-price-row">
                            <span className="featured-card-price-current">{convertPrice(prod.price, selectedCurr)}</span>
                            {prod.compare_price && prod.compare_price > prod.price && (
                              <span className="featured-card-price-compare">{convertPrice(prod.compare_price, selectedCurr)}</span>
                            )}
                          </div>
                        )}
                        {prod.name.toLowerCase().includes('super novel') ? (
                          <a
                            href="https://gem.gov.in"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="featured-add-btn-solid flex-center"
                            style={{ textDecoration: 'none', display: 'flex', justifyContent: 'center', alignItems: 'center' }}
                          >
                            Buy on GeM ➔
                          </a>
                        ) : (
                          <button
                            className="featured-add-btn-solid flex-center"
                            disabled
                            style={{ background: '#f4f7f3', border: '1px dashed #b2cbb0', color: '#7a8c78', cursor: 'not-allowed', display: 'flex', justifyContent: 'center', alignItems: 'center' }}
                          >
                            Launching Soon
                          </button>
                        )}
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </section>

          {/* Client Testimonials */}
          <section className="testimonials-section">
            <div className="container">
              <div className="testimonials-header text-center">
                <h2>{t('clientTestimonials')}</h2>
                <p>{t('whatCustomersSay')}</p>
              </div>

              <div className="testimonials-window">
                <div
                  className={`testimonials-track ${noTransition ? 'no-transition' : ''}`}
                  style={{
                    transform: `translateX(-${(currentTestimonialIndex + 1) * (100 / testItemsPerView)}%)`
                  }}
                >
                  {renderedTestimonials.map((test, idx) => (
                    <div
                      key={idx}
                      className="testimonial-slide"
                      style={{
                        flex: `0 0 ${100 / testItemsPerView}%`,
                        padding: '0 12px'
                      }}
                    >
                      <div className="testimonial-card">
                        <div className="testimonial-header">
                          <img src={test.avatar} alt={test.author} className="user-avatar" />
                          <div className="user-info">
                            <h4>{test.author}</h4>
                            <p className="user-role">{test.role}</p>
                          </div>
                        </div>
                        <p className="quote-text">“{test.text}”</p>
                      </div>
                    </div>
                  ))}
                </div>
              </div>

              <div className="testimonials-slider-navigation text-center">
                <div className="slider-arrows">
                  <button className="arrow-btn" onClick={handlePrevTestimonial} aria-label="Previous Testimonial">
                    <SVGIcon name="arrowLeft" size={20} />
                  </button>
                  <button className="arrow-btn" onClick={handleNextTestimonial} aria-label="Next Testimonial">
                    <SVGIcon name="arrowRight" size={20} />
                  </button>
                </div>
              </div>
            </div>
          </section>

          {/* Farming Knowledge Hub */}
          <section className="knowledge-hub-section" id="knowledge">
            <div className="container">
              <div className="section-header text-center">
                <span className="section-subtitle-tag">Knowledge Hub</span>
                <h2>Latest Insights & Farming Guides</h2>
              </div>

              <div className="blogs-grid">
                {latestBlogs.map((blog, idx) => {
                  const blogObj = {
                    id: blog.id || idx + 1,
                    title: blog.title,
                    slug: blog.slug || blog.title.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/(^-|-$)/g, ''),
                    category: blog.category,
                    image: blog.image,
                    date: blog.date,
                    month: blog.month,
                    summary: blog.summary
                  };
                  return (
                    <div
                      key={blogObj.id}
                      className="blog-card"
                      onClick={() => navigateToBlog(blogObj)}
                      style={{ cursor: 'pointer' }}
                    >
                      <div className="blog-image-box">
                        <img src={blogObj.image} alt={blogObj.title} className="blog-img" />
                        <div className="blog-date-badge">
                          <span className="day">{blogObj.date}</span>
                          <span className="month">{blogObj.month}</span>
                        </div>
                      </div>
                      <div className="blog-body">
                        <div className="blog-meta">
                          <span className="blog-cat">🏷️ {blogObj.category}</span>
                          <span className="blog-author">👤 By {blog.author || 'Admin'}</span>
                          <span className="blog-comments">💬 {blog.commentsCount !== undefined ? blog.commentsCount : 0} Comments</span>
                        </div>
                        <h3>{blogObj.title}</h3>
                        <button className="btn-text-link flex-center">
                          Read More <SVGIcon name="arrowRight" size={14} />
                        </button>
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
          </section>

          {/* Video Promo Banner Section (Wrapped in container to fix alignment) */}
          <section className="video-promo-section">
            <div className="container">
              <div className="video-banner-card" style={{ backgroundImage: `url('/banner/Video Bnner.png')` }}>
                <div className="video-overlay-tint"></div>
                <div className="video-content-box">
                  <h2>Made in India. Powered by Nature. Trusted Globally.</h2>
                  <button className="video-play-btn" onClick={() => setIsVideoModalOpen(true)} aria-label="Play promotional video">
                    <SVGIcon name="play" size={26} fill="#ffffff" stroke="#ffffff" />
                  </button>
                </div>
              </div>
            </div>
          </section>
          {/* <section className="video-promo-section">
            <div className="container">
              <div className="video-banner-card" style={{ position: 'relative', overflow: 'hidden' }}>
                <video autoPlay loop muted playsInline className="video-bg" style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', objectFit: 'cover', zIndex: 1 }}>
                  <source src="/video/orbifert-video-super-novel.mp4" type="video/mp4" />
                </video>
                <div className="video-overlay-tint" style={{ zIndex: 2 }}></div>

              </div>
            </div>
          </section> */}

          {/* Brand Partners Row */}
          <section className="partners-section">
            <div className="partners-marquee">
              <div className="partners-marquee-content">
                <div className="partner-logo">steps</div>
                <div className="partner-logo margo">MARGO</div>
                <div className="partner-logo food">food</div>
                <div className="partner-logo food-bold">FOOD</div>
                <div className="partner-logo book-off">BOOK-OFF</div>
                <div className="partner-logo g-series">G Series</div>

                {/* Duplicated set for seamless loop scrolling */}
                <div className="partner-logo">steps</div>
                <div className="partner-logo margo">MARGO</div>
                <div className="partner-logo food">food</div>
                <div className="partner-logo food-bold">FOOD</div>
                <div className="partner-logo book-off">BOOK-OFF</div>
                <div className="partner-logo g-series">G Series</div>
              </div>
            </div>
          </section>
        </>
      )}

      {/* Extracted Reusable Footer Component */}
      {activePage !== 'admin' && activePage !== '404' && activePage !== 'checkout' && activePage !== 'ios-app' && activePage !== 'apk-app' && (
        <Footer
          triggerNotification={triggerNotification}
          showNewsletter={activePage !== 'shop'}
          onNavigate={handleNavigate}
          onOpenOrderHistory={handleOpenOrderHistory}
          onOpenWishlist={() => setIsWishlistOpen(true)}
          onOpenCart={() => setIsCartOpen(true)}
          onOpenProfile={handleOpenProfile}
        />
      )}

      {/* Authentication Modal Popup */}
      <AuthModal
        isOpen={isAuthOpen}
        onClose={() => setIsAuthOpen(false)}
        defaultMode={authMode}
        triggerNotification={triggerNotification}
        onLoginSuccess={(user) => {
          setCurrentUser(user);
          window.dispatchEvent(new CustomEvent('auth-state-change'));
        }}
      />

      {/* Video Player Modal Popup */}
      {isVideoModalOpen && (
        <div className="video-modal-overlay" onClick={() => setIsVideoModalOpen(false)}>
          <div className="video-modal-card" onClick={(e) => e.stopPropagation()}>
            <button className="video-modal-close-btn" onClick={() => setIsVideoModalOpen(false)} aria-label="Close video">
              ✕
            </button>
            <div className="video-player-container">
              <video
                src="/video/Orbifert.mp4"
                controls
                autoPlay
                playsInline
              />
            </div>
          </div>
        </div>
      )}

      {/* Slide-out Sidebar Drawers Overlay Backdrop */}
      <div className={`drawer-overlay ${(isCartOpen || isWishlistOpen) ? 'open' : ''}`} onClick={closeDrawers}></div>

      {/* Wishlist Drawer */}
      <div className={`sidebar-drawer ${isWishlistOpen ? 'open' : ''}`}>
        <div className="drawer-header">
          <h2>Wishlist</h2>
          <button className="drawer-close-btn-x" onClick={closeDrawers} aria-label="Close Wishlist">
            <SVGIcon name="close" size={20} />
          </button>
        </div>
        <div className="drawer-body">
          {wishlistItems.length === 0 ? (
            <div className="drawer-empty-state">
              <div className="empty-icon" style={{ fontSize: '36px' }}>❤️</div>
              <p>Your wishlist is empty</p>
            </div>
          ) : (
            wishlistItems.map((item) => (
              <div key={item.id} className="drawer-item-card">
                <div className="drawer-item-img-wrap">
                  <img
                    src={item.image}
                    alt={item.title}
                    className="drawer-item-img"
                    onClick={() => navigateToProduct({ id: item.id, title: item.title, price: item.price, image: item.image })}
                    style={{ cursor: 'pointer' }}
                  />
                </div>
                <div className="drawer-item-details">
                  <span
                    className="drawer-item-title"
                    onClick={() => navigateToProduct({ id: item.id, title: item.title, price: item.price, image: item.image })}
                    style={{ cursor: 'pointer' }}
                  >
                    {item.title}
                  </span>
                  <span className="drawer-item-price">{convertPrice(item.price, selectedCurr)}</span>
                </div>
                <div className="drawer-item-actions">
                  <button className="remove-item-btn" onClick={() => handleRemoveFromWishlist(item.id)} aria-label="Remove from Wishlist">
                    <SVGIcon name="close" size={16} />
                  </button>
                  <button
                    className="wishlist-add-to-cart-btn"
                    onClick={() => {
                      handleAddToCart(item);
                      handleRemoveFromWishlist(item.id);
                      setIsWishlistOpen(false);
                      setIsCartOpen(true);
                    }}
                  >
                    Add <SVGIcon name="cart" size={12} stroke="#ffffff" />
                  </button>
                </div>
              </div>
            ))
          )}
        </div>
      </div>

      {/* Shopping Cart Drawer */}
      <div className={`sidebar-drawer ${isCartOpen ? 'open' : ''}`}>
        <div className="drawer-header">
          <h2>Shopping Cart</h2>
          <button className="drawer-close-btn-x" onClick={closeDrawers} aria-label="Close Cart">
            <SVGIcon name="close" size={20} />
          </button>
        </div>
        <div className="drawer-body">
          {cartItems.length === 0 ? (
            <div className="drawer-empty-state">
              <div className="empty-icon" style={{ fontSize: '36px' }}>🛒</div>
              <p>Your shopping cart is empty</p>
            </div>
          ) : (
            cartItems.map((item) => (
              <div key={item.id} className="drawer-item-card">
                <div className="drawer-item-img-wrap">
                  <img
                    src={item.image}
                    alt={item.title}
                    className="drawer-item-img"
                    onClick={() => navigateToProduct({ id: item.id, title: item.title, price: item.price, image: item.image })}
                    style={{ cursor: 'pointer' }}
                  />
                </div>
                <div className="drawer-item-details">
                  <span
                    className="drawer-item-title"
                    onClick={() => navigateToProduct({ id: item.id, title: item.title, price: item.price, image: item.image })}
                    style={{ cursor: 'pointer' }}
                  >
                    {item.title}
                  </span>
                  <span className="drawer-item-price">{convertPrice(item.price * item.qty, selectedCurr)}</span>
                  <div className="drawer-item-qty-row">
                    <div className="qty-control">
                      <button className="qty-control-btn" onClick={() => handleCartQtyChange(item.id, -1)}>-</button>
                      <span className="qty-control-val">{item.qty}</span>
                      <button className="qty-control-btn" onClick={() => handleCartQtyChange(item.id, 1)}>+</button>
                    </div>
                  </div>
                </div>
                <div className="drawer-item-actions">
                  <button className="remove-item-btn" onClick={() => handleRemoveFromCart(item.id)} aria-label="Remove from Cart">
                    <SVGIcon name="close" size={16} />
                  </button>
                </div>
              </div>
            ))
          )}
        </div>
        {cartItems.length > 0 && (
          <div className="drawer-footer">
            <div className="cart-subtotal-row">
              <span className="subtotal-label">Subtotal:</span>
              <span className="subtotal-value">
                {convertPrice(cartItems.reduce((sum, item) => sum + (item.price * item.qty), 0), selectedCurr)}
              </span>
            </div>
            <button
              className="btn btn-primary checkout-btn"
              onClick={() => {
                if (cartItems.length === 0) {
                  triggerNotification("Your cart is empty!");
                  return;
                }
                if (currentUser && currentUser.roles && currentUser.roles.includes('Master Admin')) {
                  setIsCartOpen(false);
                  setIsMasterAdminPromptOpen(true);
                  return;
                }
                if (!currentUser) {
                  triggerNotification("Please sign in or sign up to proceed with checkout.");
                  setIsCartOpen(false);
                  setAuthMode('login');
                  setIsAuthOpen(true);
                  return;
                }
                setIsCartOpen(false);
                const firstItem = cartItems[0];
                const targetId = firstItem ? (firstItem.variant_id || firstItem.id) : '';
                navigate(`/checkout/${targetId}`);
              }}
            >
              Proceed To Checkout
            </button>
          </div>
        )}
      </div>

      {/* Admin Portal Modal Popup */}
      <div className={`admin-modal-overlay ${isAdminOpen ? 'open' : ''}`} onClick={() => setIsAdminOpen(false)}>
        <div className="admin-modal-card animate-scale-up" onClick={(e) => e.stopPropagation()}>
          <button className="admin-modal-close" onClick={() => setIsAdminOpen(false)} aria-label="Close Admin Portal">
            ✕
          </button>
          <h2>Master Admin Control Panel</h2>

          <div className="admin-tab-triggers">
            <button
              className={`admin-tab-btn ${adminTab === 'catalog' ? 'active' : ''}`}
              onClick={() => setAdminTab('catalog')}
            >
              📦 Catalog Manager
            </button>
            <button
              className={`admin-tab-btn ${adminTab === 'orders' ? 'active' : ''}`}
              onClick={() => { setAdminTab('orders'); fetchAdminOrders(); }}
            >
              🛒 Orders
            </button>
            <button
              className={`admin-tab-btn ${adminTab === 'logs' ? 'active' : ''}`}
              onClick={() => setAdminTab('logs')}
            >
              📋 Audit Logs
            </button>
          </div>

          <div className="admin-tab-content">
            {adminTab === 'catalog' && (
              <div className="catalog-crud-layout">
                {/* Product List */}
                <div className="catalog-list-panel">
                  <h3>Active Products ({adminProducts.length})</h3>
                  <div className="admin-products-list">
                    {adminProducts.length === 0 ? (
                      <p style={{ color: '#aaa', fontSize: '13px' }}>No products found in catalog.</p>
                    ) : (
                      adminProducts.map((p) => (
                        <div key={p.id} className="admin-product-row">
                          <div className="admin-prod-info">
                            <span className="admin-prod-title">{p.title}</span>
                            <span className="admin-prod-sku">SKU: {p.sku}</span>
                          </div>
                          <button
                            className="admin-delete-btn"
                            onClick={() => handleDeleteProduct(p.id)}
                          >
                            Delete
                          </button>
                        </div>
                      ))
                    )}
                  </div>
                </div>

                {/* Create Product Form */}
                <div className="catalog-form-panel">
                  <h3>Create New Product Listing</h3>
                  <form onSubmit={handleCreateProduct} className="admin-form-grid">
                    <div className="admin-form-group">
                      <label>Product Title *</label>
                      <input
                        type="text"
                        value={adminProductForm.title}
                        onChange={(e) => setAdminProductForm({ ...adminProductForm, title: e.target.value })}
                        placeholder="e.g. Super Novel (200ml)"
                        required
                      />
                    </div>
                    <div className="admin-form-group">
                      <label>Base SKU *</label>
                      <input
                        type="text"
                        value={adminProductForm.sku}
                        onChange={(e) => setAdminProductForm({ ...adminProductForm, sku: e.target.value })}
                        placeholder="e.g. SN-200"
                        required
                      />
                    </div>
                    <div className="admin-form-group">
                      <label>Category *</label>
                      <select
                        value={adminProductForm.category_id}
                        onChange={(e) => setAdminProductForm({ ...adminProductForm, category_id: e.target.value })}
                      >
                        <option value="1">Fertilizers</option>
                        <option value="2">Bio Fertilizers</option>
                        <option value="3">Soil Conditioners</option>
                      </select>
                    </div>
                    <div className="admin-form-group">
                      <label>Base Price (INR) *</label>
                      <input
                        type="number"
                        step="0.01"
                        value={adminProductForm.price}
                        onChange={(e) => setAdminProductForm({ ...adminProductForm, price: e.target.value })}
                        placeholder="e.g. 140.99"
                        required
                      />
                    </div>
                    <div className="admin-form-group full-width">
                      <label>Short Description</label>
                      <input
                        type="text"
                        value={adminProductForm.short_description}
                        onChange={(e) => setAdminProductForm({ ...adminProductForm, short_description: e.target.value })}
                        placeholder="Brief summary..."
                      />
                    </div>
                    <div className="admin-form-group full-width">
                      <label>Full Description</label>
                      <textarea
                        rows="2"
                        value={adminProductForm.description}
                        onChange={(e) => setAdminProductForm({ ...adminProductForm, description: e.target.value })}
                        placeholder="Detailed specifications and features..."
                      ></textarea>
                    </div>

                    <div className="admin-form-group">
                      <label>Specification Label</label>
                      <input
                        type="text"
                        value={adminProductForm.specs_label}
                        onChange={(e) => setAdminProductForm({ ...adminProductForm, specs_label: e.target.value })}
                        placeholder="e.g. Formulation"
                      />
                    </div>
                    <div className="admin-form-group">
                      <label>Specification Value</label>
                      <input
                        type="text"
                        value={adminProductForm.specs_value}
                        onChange={(e) => setAdminProductForm({ ...adminProductForm, specs_value: e.target.value })}
                        placeholder="e.g. Concentrated Liquid"
                      />
                    </div>

                    <button type="submit" className="admin-submit-btn full-width">
                      Publish Product
                    </button>
                  </form>
                </div>
              </div>
            )}

            {adminTab === 'orders' && (
              <div className="admin-orders-panel">
                <h3>All Customer Orders ({adminOrders.length})</h3>
                <div style={{ maxHeight: '55vh', overflowY: 'auto', display: 'flex', flexDirection: 'column', gap: '12px', paddingRight: '8px' }}>
                  {adminOrders.length === 0 ? (
                    <p style={{ color: '#aaa', fontSize: '13px' }}>No orders found.</p>
                  ) : (
                    adminOrders.map((order) => (
                      <div key={order.id} className="admin-order-card">
                        <div className="admin-order-header" onClick={() => setExpandedOrderId(expandedOrderId === order.id ? null : order.id)}>
                          <div className="admin-order-header-left">
                            <span className="admin-order-number">#{order.order_number}</span>
                            <span className={`admin-order-status-badge status-${order.status}`}>{order.status}</span>
                            {order.packaging_status && <span className="admin-order-pkg-badge">{order.packaging_status}</span>}
                          </div>
                          <div className="admin-order-header-right">
                            <span className="admin-order-total">₹{parseFloat(order.total_amount).toFixed(2)}</span>
                            <span className="admin-order-date">{new Date(order.created_at).toLocaleDateString('en-IN')}</span>
                            <span className="admin-order-expand-icon">{expandedOrderId === order.id ? '▲' : '▼'}</span>
                          </div>
                        </div>

                        {expandedOrderId === order.id && (
                          <div className="admin-order-details">
                            {/* Customer Info */}
                            <div className="admin-order-section">
                              <h4>Customer</h4>
                              <p>{order.first_name} {order.last_name} &bull; {order.user_email}</p>
                              <p>📞 {order.user_phone || 'N/A'}</p>
                            </div>

                            {/* Shipping Address */}
                            <div className="admin-order-section">
                              <h4>Shipping Address</h4>
                              <p><strong>{order.shipping_name}</strong></p>
                              <p>{order.shipping_line1}, {order.shipping_line2}{order.shipping_landmark ? `, ${order.shipping_landmark}` : ''}</p>
                              <p>{order.shipping_city}, {order.shipping_state} - {order.shipping_pincode}</p>
                              <p>📞 {order.shipping_phone}{order.shipping_alt_phone ? ` / ${order.shipping_alt_phone}` : ''}</p>
                            </div>

                            {/* Order Items */}
                            <div className="admin-order-section">
                              <h4>Items</h4>
                              {order.items && order.items.map((item, idx) => (
                                <div key={idx} className="admin-order-item-row">
                                  <span>{item.title} ({item.sku})</span>
                                  <span>x{item.quantity} — ₹{parseFloat(item.price).toFixed(2)}</span>
                                </div>
                              ))}
                            </div>

                            {/* Payment Info */}
                            <div className="admin-order-section">
                              <h4>Payment</h4>
                              <p>Method: <strong>{order.payment_method || 'COD'}</strong> &bull; Status: <strong>{order.payment_status}</strong></p>
                              <p>Tax: ₹{parseFloat(order.tax_amount || 0).toFixed(2)} &bull; Shipping: ₹{parseFloat(order.shipping_amount || 0).toFixed(2)}</p>
                            </div>

                            {/* Status & Tracking Controls */}
                            <div className="admin-order-section admin-order-controls">
                              <h4>Update Order</h4>
                              <div className="admin-order-controls-grid">
                                <div className="admin-form-group">
                                  <label>Order Status</label>
                                  <select
                                    defaultValue={order.status}
                                    id={`status-${order.id}`}
                                  >
                                    <option value="pending">Pending</option>
                                    <option value="processing">Processing / Accepted</option>
                                    <option value="shipped">Shipped / Dispatched</option>
                                    <option value="delivered">Delivered</option>
                                    <option value="cancelled">Cancelled</option>
                                    <option value="refunded">Refunded</option>
                                  </select>
                                </div>
                                <div className="admin-form-group">
                                  <label>Packaging Status</label>
                                  <select
                                    defaultValue={order.packaging_status || ''}
                                    id={`pkg-${order.id}`}
                                  >
                                    <option value="">Not Set</option>
                                    <option value="packing">Packing</option>
                                    <option value="packed">Packed & Ready</option>
                                    <option value="handed_to_courier">Handed to Courier</option>
                                  </select>
                                </div>
                                <div className="admin-form-group">
                                  <label>Tracking Link (India Express / Courier)</label>
                                  <input
                                    type="url"
                                    defaultValue={order.tracking_link || ''}
                                    id={`track-link-${order.id}`}
                                    placeholder="https://www.indiaexpress.com/tracking/..."
                                  />
                                </div>
                                <div className="admin-form-group">
                                  <label>Tracking ID / AWB Number</label>
                                  <input
                                    type="text"
                                    defaultValue={order.tracking_id || ''}
                                    id={`track-id-${order.id}`}
                                    placeholder="e.g. INEXP123456789"
                                  />
                                </div>
                              </div>
                              <button
                                className="admin-submit-btn"
                                style={{ marginTop: '12px' }}
                                disabled={adminOrderUpdating === order.id}
                                onClick={() => {
                                  const status = document.getElementById(`status-${order.id}`).value;
                                  const packaging_status = document.getElementById(`pkg-${order.id}`).value;
                                  const tracking_link = document.getElementById(`track-link-${order.id}`).value;
                                  const tracking_id = document.getElementById(`track-id-${order.id}`).value;
                                  handleUpdateOrderAdmin(order.id, { status, packaging_status, tracking_link, tracking_id });
                                }}
                              >
                                {adminOrderUpdating === order.id ? 'Updating...' : '✅ Save Changes'}
                              </button>
                            </div>
                          </div>
                        )}
                      </div>
                    ))
                  )}
                </div>
              </div>
            )}

            {adminTab === 'logs' && (
              <div className="admin-logs-panel">
                <h3>Admin Activity Logs (Last 100 entries)</h3>
                <div style={{ maxHeight: '50vh', overflowY: 'auto', display: 'flex', flexDirection: 'column', gap: '10px', paddingRight: '8px' }}>
                  {adminLogs.length === 0 ? (
                    <p style={{ color: '#aaa', fontSize: '13px' }}>No activity logs recorded.</p>
                  ) : (
                    adminLogs.map((log) => (
                      <div key={log.id} className="admin-log-item">
                        <div className="log-meta-row">
                          <span className="log-action">{log.action}</span>
                          <span>{new Date(log.created_at).toLocaleString()}</span>
                        </div>
                        <p className="log-desc">{log.description}</p>
                        <span style={{ fontSize: '10px', color: '#999' }}>Target: {log.target_table} (ID: {log.target_id}) &bull; IP: {log.ip_address || 'Internal'}</span>
                      </div>
                    ))
                  )}
                </div>
              </div>
            )}
          </div>
        </div>
      </div>

      {showScrollTop && (
        <button
          className="scroll-to-top-btn"
          onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
          aria-label="Scroll to top"
        >
          <SVGIcon name="chevronUp" size={22} stroke="#ffffff" />
        </button>
      )}
    </div>
  );
}
